// import React, { useState, useEffect, useRef } from "react";
// import { getDatabase, ref, push, set, onValue, off, update, remove, get } from "firebase/database";
// import { auth } from "../firebase";
// import { onAuthStateChanged } from "firebase/auth";

// const OpeningStock = ({ onSuccess, onCancel, initialData }) => {
//   const [items, setItems] = useState(
//     initialData?.items || [
//       { itemDescription: "", uom: "", qty: "", tax: "", taxAmount: "", mrp: "", value: "" },
//     ]
//   );
//   const [account, setAccount] = useState(initialData?.account || "OPENING STOCK");
//   const [branch, setBranch] = useState(initialData?.branch || "");
//   const [location, setLocation] = useState(initialData?.location || "WAREHOUSE");
//   const [refNo, setRefNo] = useState(initialData?.refNo || 1);
//   const [refDate, setRefDate] = useState(
//     initialData?.refDate || new Date().toISOString().split('T')[0]
//   );
//   const [showAddProductForm, setShowAddProductForm] = useState(false);
//   const [productForm, setProductForm] = useState({
//     productCode: "",
//     hsnCode: "",
//     productName: "",
//     barcode: "",
//     group: "",
//     category: "",
//     brand: "",
//     uom: "",
//     mrp: "",
//     sellingPrice: "",
//     purchaseTax: "0",
//     salesTax: "0",
//     styleNo: "",
//   });
//   const [currentUser, setCurrentUser] = useState(null);
//   const [groups, setGroups] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [brands, setBrands] = useState([]);
//   const [units, setUnits] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [branchProfile, setBranchProfile] = useState(null);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [successMessage, setSuccessMessage] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [suggestions, setSuggestions] = useState([]);
//   const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(-1);
//   const [focusedItemIndex, setFocusedItemIndex] = useState(null);
//   const suggestionRefs = useRef([]);

//   const database = getDatabase();

//   const encodeEmailForPath = (email) => {
//     if (!email) return "";
//     return email.replace(/[.#$[\]]/g, "_");
//   };

//   // Fetch current user
//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       setCurrentUser(user);
//       setLoading(false);
//     });
//     return () => unsubscribe();
//   }, []);

//   useEffect(() => {
//   if (!currentUser || initialData) return;

//   const encodedEmail = encodeEmailForPath(currentUser.email);
//   const stockRef = ref(database, `users/${encodedEmail}/openingStock`);
//   get(stockRef)
//     .then((snapshot) => {
//       let maxRefNo = 0;
//       if (snapshot.exists()) {
//         const stockEntries = snapshot.val();
//         const refNos = Object.values(stockEntries)
//           .map((entry) => parseInt(entry.refNo, 10))
//           .filter((num) => !isNaN(num));
//         maxRefNo = refNos.length > 0 ? Math.max(...refNos) : 0;
//       }
//       setRefNo(maxRefNo + 1 || 1);
//     })
//     .catch((error) => {
//       console.error('Error fetching Ref No:', error);
//       setErrorMessage('Failed to fetch Ref No.');
//     });
// }, [currentUser, initialData]);

//   // Fetch groups, categories, brands, units, products, and branch profile
//   useEffect(() => {
//     if (!currentUser || !currentUser.email) return;

//     setLoading(true);
//     const encodedEmail = encodeEmailForPath(currentUser.email);
//     if (!encodedEmail) {
//       setErrorMessage("Invalid user email. Cannot fetch data.");
//       setLoading(false);
//       return;
//     }

//     const groupsRef = ref(database, `users/${encodedEmail}/productGroups`);
//     const categoriesRef = ref(database, `users/${encodedEmail}/categories`);
//     const brandsRef = ref(database, `users/${encodedEmail}/brands`);
//     const unitsRef = ref(database, `users/${encodedEmail}/units`);
//     const productsRef = ref(database, `users/${encodedEmail}/products`);
//     const branchProfileRef = ref(database, `users/${encodedEmail}/branchProfiles`);

//     const listeners = [
//       { ref: groupsRef, setData: setGroups },
//       { ref: categoriesRef, setData: setCategories },
//       { ref: brandsRef, setData: setBrands },
//       { ref: unitsRef, setData: setUnits },
//       { ref: productsRef, setData: setProducts },
//     ];

//     listeners.forEach(({ ref, setData }) => {
//       onValue(
//         ref,
//         (snapshot) => {
//           const data = [];
//           snapshot.forEach((childSnapshot) => {
//             data.push({ id: childSnapshot.key, ...childSnapshot.val() });
//           });
//           setData(data);
//         },
//         (error) => {
//           console.error(`Error fetching data:`, error);
//           setErrorMessage(`Failed to load data: ${error.message}`);
//         }
//       );
//     });

//     // Fetch branch profile
//     onValue(
//       branchProfileRef,
//       (snapshot) => {
//         const data = snapshot.val();
//         if (data) {
//           const profiles = Object.values(data);
//           if (profiles.length > 0) {
//             const latestProfile = profiles[profiles.length - 1];
//             setBranchProfile(latestProfile);
//             if (!initialData) {
//               setBranch(latestProfile.branchName || "WAREHOUSE");
//             }
//           }
//         }
//         setLoading(false);
//       },
//       (error) => {
//         console.error("Error fetching branch profile:", error);
//         setErrorMessage(`Failed to load branch profile: ${error.message}`);
//         setLoading(false);
//       }
//     );

//     return () => {
//       listeners.forEach(({ ref }) => off(ref));
//       off(branchProfileRef);
//     };
//   }, [currentUser, initialData]);

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (
//         suggestionRefs.current.every((ref) => ref && !ref.contains(e.target)) &&
//         !e.target.closest('input')
//       ) {
//         setSuggestions([]);
//         setFocusedItemIndex(null);
//         setActiveSuggestionIndex(-1);
//       }
//     };

//     document.addEventListener('click', handleClickOutside);
//     return () => document.removeEventListener('click', handleClickOutside);
//   }, []);

//   // Handle item changes
//   const handleItemChange = (index, field, value) => {
//     const updatedItems = [...items];
//     if (field === "itemDescription") {
//       updatedItems[index][field] = value;
//       if (value.trim()) {
//         const filtered = products.filter((p) =>
//           p.productName && p.productName.toLowerCase().includes(value.toLowerCase())
//         );
//         setSuggestions(filtered.slice(0, 5));
//         setFocusedItemIndex(index);
//         setActiveSuggestionIndex(-1);
//       } else {
//         setSuggestions([]);
//         setFocusedItemIndex(null);
//       }
//     } else {
//       updatedItems[index][field] = value;
//     }

//     if (field === "qty" || field === "tax" || field === "mrp") {
//       const qty = parseFloat(updatedItems[index].qty) || 0;
//       const tax = parseFloat(updatedItems[index].tax) || 0;
//       const mrp = parseFloat(updatedItems[index].mrp) || 0;

//       const taxAmount = (mrp * qty * tax) / 100;
//       const value = mrp * qty + taxAmount;

//       updatedItems[index].taxAmount = taxAmount.toFixed(2);
//       updatedItems[index].value = value.toFixed(2);
//     }

//     setItems(updatedItems);
//   };

//   const handleSelect = (index, product) => {
//     const updatedItems = [...items];
//     updatedItems[index] = {
//       itemDescription: product.productName || "",
//       uom: product.uom || product.unit || "",
//       qty: updatedItems[index].qty || "",
//       tax: product.salesTax || "0",
//       taxAmount: "",
//       mrp: product.mrp || "0",
//       value: "",
//     };
//     const qty = parseFloat(updatedItems[index].qty) || 0;
//     const tax = parseFloat(updatedItems[index].tax) || 0;
//     const mrp = parseFloat(updatedItems[index].mrp) || 0;
//     const taxAmount = (mrp * qty * tax) / 100;
//     const value = mrp * qty + taxAmount;
//     updatedItems[index].taxAmount = taxAmount.toFixed(2);
//     updatedItems[index].value = value.toFixed(2);
//     setItems(updatedItems);
//     setSuggestions([]);
//     setFocusedItemIndex(null);
//     setActiveSuggestionIndex(-1);
//   };

//   const handleKeyDown = (e, index) => {
//     if (focusedItemIndex !== index || suggestions.length === 0) return;

//     if (e.key === 'ArrowDown') {
//       e.preventDefault();
//       setActiveSuggestionIndex((prev) =>
//         prev < suggestions.length - 1 ? prev + 1 : prev
//       );
//     } else if (e.key === 'ArrowUp') {
//       e.preventDefault();
//       setActiveSuggestionIndex((prev) => (prev > 0 ? prev - 1 : prev));
//     } else if (e.key === 'Enter' && activeSuggestionIndex >= 0) {
//       e.preventDefault();
//       handleSelect(index, suggestions[activeSuggestionIndex]);
//     } else if (e.key === 'Escape') {
//       setSuggestions([]);
//       setFocusedItemIndex(null);
//       setActiveSuggestionIndex(-1);
//     }
//   };

//   const addNewLine = () => {
//     setItems([
//       ...items,
//       { itemDescription: "", uom: "", qty: "", tax: "", taxAmount: "", mrp: "", value: "" },
//     ]);
//   };

//   const saveToFirestore = async () => {
//     setErrorMessage("");
//     setSuccessMessage("");
//     if (!currentUser || !currentUser.email) {
//       setErrorMessage("You must be logged in with a valid email to save data!");
//       return;
//     }

//     const encodedEmail = encodeEmailForPath(currentUser.email);
//     try {
//       const nonEmptyItems = items.filter(
//         (item) =>
//           item.itemDescription.trim() !== "" &&
//           item.qty !== "" &&
//           item.mrp !== "" &&
//           !isNaN(parseFloat(item.qty)) &&
//           !isNaN(parseFloat(item.mrp))
//       );

//       if (nonEmptyItems.length === 0) {
//         setErrorMessage("Please add at least one valid item with product, quantity, and MRP!");
//         return;
//       }

//       const stockData = {
//         refNo,
//         refDate,
//         account,
//         branch,
//         location,
//         items: nonEmptyItems,
//         createdAt: new Date().toISOString(),
//       };

//       if (initialData?.id) {
//         // Update existing stock entry
//         const stockRef = ref(database, `users/${encodedEmail}/openingStock/${initialData.id}`);
//         // Revert previous stock quantities
//         const oldStock = initialData.items || [];
//         for (const item of oldStock) {
//           const product = products.find(p => p.productName === item.itemDescription);
//           if (product) {
//             const qty = parseFloat(item.qty) || 0;
//             const currentStock = parseFloat(product.openingStock) || 0;
//             const newStock = currentStock - qty;
//             const productRef = ref(database, `users/${encodedEmail}/products/${product.id}`);
//             await update(productRef, { openingStock: newStock.toString() });
//           }
//         }
//         // Update with new data
//         await update(stockRef, stockData);
//         // Update product stock for new items
//         for (const item of nonEmptyItems) {
//           const product = products.find(p => p.productName === item.itemDescription);
//           if (product) {
//             const qty = parseFloat(item.qty);
//             const currentStock = parseFloat(product.openingStock) || 0;
//             const newStock = currentStock + qty;
//             const productRef = ref(database, `users/${encodedEmail}/products/${product.id}`);
//             await update(productRef, { openingStock: newStock.toString() });
//           }
//         }
//         setSuccessMessage("Stock updated successfully!");
//       } else {
//         // Create new stock entry
//         const newStockRef = push(ref(database, `users/${encodedEmail}/openingStock`));
//         await set(newStockRef, stockData);
//         // Update product opening stock
//         for (const item of nonEmptyItems) {
//           const product = products.find(p => p.productName === item.itemDescription);
//           if (product) {
//             const qty = parseFloat(item.qty);
//             const currentStock = parseFloat(product.openingStock) || 0;
//             const newStock = currentStock + qty;
//             const productRef = ref(database, `users/${encodedEmail}/products/${product.id}`);
//             await update(productRef, { openingStock: newStock.toString() });
//           }
//         }
//         setSuccessMessage("Data saved successfully!");
//       }

//       onSuccess();
//     } catch (error) {
//       console.error("Error saving data:", error);
//       setErrorMessage(`Failed to save data: ${error.message}`);
//     }
//   };

//   const handleProductFormChange = (field, value) => {
//     setProductForm((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   const addProduct = async () => {
//     setErrorMessage("");
//     setSuccessMessage("");
//     if (!currentUser || !currentUser.email) {
//       setErrorMessage("You must be logged in with a valid email to add a product!");
//       return;
//     }

//     const encodedEmail = encodeEmailForPath(currentUser.email);
//     try {
//       if (!productForm.productName || !productForm.uom) {
//         setErrorMessage("Please fill all required fields (Product Name, UOM)!");
//         return;
//       }

//       const productData = {
//         ...productForm,
//         createdAt: new Date().toISOString(),
//         createdBy: currentUser.email,
//         mrp: parseFloat(productForm.mrp) || 0,
//         sellingPrice: parseFloat(productForm.sellingPrice) || 0,
//         purchaseTax: parseFloat(productForm.purchaseTax) || 0,
//         salesTax: parseFloat(productForm.salesTax) || 0,
//         openingStock: "0",
//       };

//       const newProductRef = push(ref(database, `users/${encodedEmail}/products`));
//       await set(newProductRef, productData);

//       setSuccessMessage("Product added successfully!");
//       setShowAddProductForm(false);
//       setProductForm({
//         productCode: "",
//         hsnCode: "",
//         productName: "",
//         barcode: "",
//         group: "",
//         category: "",
//         brand: "",
//         uom: "",
//         mrp: "",
//         sellingPrice: "",
//         purchaseTax: "0",
//         salesTax: "0",
//         styleNo: "",
//       });
//     } catch (error) {
//       console.error("Error adding product:", error);
//       setErrorMessage(`Failed to add product: ${error.message}`);
//     }
//   };

//   const cancel = () => {
//     setItems([{ itemDescription: "", uom: "", qty: "", tax: "", taxAmount: "", mrp: "", value: "" }]);
//     setAccount("OPENING STOCK");
//     setBranch(branchProfile?.branchName || "WAREHOUSE");
//     setLocation("WAREHOUSE");
//     setRefDate(new Date().toISOString().split('T')[0]);
//     setErrorMessage("");
//     setSuccessMessage("");
//     setShowAddProductForm(false);
//     onCancel();
//   };

//   // Styles
//   const styles = {
//     container: {
//       maxWidth: '1200px',
//       margin: '0 auto',
//       padding: '2rem',
//        backgroundColor: 'white',
//       minHeight: '100vh',
//       fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
//     },
//     header: {
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       marginBottom: '2rem',
//       padding: '1.5rem',
    
//     },
//     heading: {
//       fontSize: '2rem',
//       fontWeight: '700',
//       color: '#2563eb',
//       margin: '0',
//     },
//     button: {
//       padding: '0.875rem 2rem',
//       borderRadius: '8px',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '600',
//       cursor: 'pointer',
//       border: 'none',
//       fontSize: '0.95rem',
//       transition: 'all 0.3s ease',
//       boxShadow: '0 4px 15px rgba(37, 99, 235, 0.3)',
//       transform: 'translateY(0)',
    
//     },
//     button1: {
//       padding: '0.875rem 2rem',
//       borderRadius: '8px',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '600',
//       cursor: 'pointer',
//       border: 'none',
//       fontSize: '0.95rem',
//       transition: 'all 0.3s ease',
//       boxShadow: '0 4px 15px rgba(37, 99, 235, 0.3)',
//       transform: 'translateY(0)',
//        marginLeft:'900px'
//     },
//     tableContainer: {
//       backgroundColor: 'white',
//       borderRadius: '16px',
//       boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
//       border: '1px solid #e2e8f0',
//       marginBottom: '2rem',
//     },
//     table: {
//       width: '100%',
//       borderCollapse: 'collapse',
//       fontSize: '0.9rem',
//       border: '1px solid #d1d5db',
//     },
//     th: {
//       padding: '1rem 0.75rem',
//       textAlign: 'left',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '600',
//       fontSize: '0.85rem',
//       textTransform: 'uppercase',
//       letterSpacing: '0.5px',
//       border: '1px solid #1e40af',
//     },
//     td: {
//       padding: '1rem 0.75rem',
//       border: '1px solid #d1d5db',
//       color: '#374151',
//       verticalAlign: 'middle',
//     },
//     input: {
//       display: 'block',
//       width: '80%',
//       padding: '0.5rem 0.75rem',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       fontSize: '0.875rem',
//       backgroundColor: '#fff',
//       transition: 'border-color 0.2s ease',
//     },
//     select: {
//       display: 'block',
//       width: '100%',
//       padding: '0.5rem 0.75rem',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       fontSize: '0.875rem',
//       backgroundColor: '#fff',
//       cursor: 'pointer',
//       appearance: 'none',
//       backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e")`,
//       backgroundPosition: 'right 0.5rem center',
//       backgroundRepeat: 'no-repeat',
//       backgroundSize: '1em 1em',
//       paddingRight: '2rem',
//     },
//     disabledInput: {
//       backgroundColor: '#f3f4f6',
//       cursor: 'not-allowed',
//     },
//     suggestions: {
//       position: 'absolute',
//       top: '100%',
//       left: '0',
//       width: '100%',
//       backgroundColor: '#ffffff',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       zIndex: 1000,
//       maxHeight: '300px',
//       boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
//     },
//     suggestionTable: {
//       width: '100%',
//       borderCollapse: 'collapse',
//     },
//     suggestionTh: {
//       padding: '0.5rem',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '600',
//       fontSize: '0.7rem',
//       textAlign: 'center',
//       border: '1px solid #1e40af',
//     },
//     suggestionTd: {
//       padding: '0.5rem',
//       border: '1px solid #e2e8f0',
//       fontSize: '0.75rem',
//       textAlign: 'center',
//     },
//     suggestionItem: {
//       cursor: 'pointer',
//       transition: 'background-color 0.2s ease',
//     },
//     suggestionActive: {
//       backgroundColor: '#e0f2fe',
//     },
//     messageSuccess: {
//       padding: '1rem 1.5rem',
//       marginBottom: '1.5rem',
//       borderRadius: '12px',
//       backgroundColor: '#d1fae5',
//       color: '#065f46',
//       border: '1px solid #a7f3d0',
//       fontSize: '0.9rem',
//       fontWeight: '500',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '0.5rem',
//     },
//     messageError: {
//       padding: '1rem 1.5rem',
//       marginBottom: '1.5rem',
//       borderRadius: '12px',
//       backgroundColor: '#fee2e2',
//       color: '#b91c1c',
//       border: '1px solid #fecaca',
//       fontSize: '0.9rem',
//       fontWeight: '500',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '0.5rem',
//     },
//     modal: {
//       position: 'fixed',
//       top: '0',
//       left: '0',
//       right: '0',
//       bottom: '0',
//       backgroundColor: 'rgba(0,0,0,0.5)',
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       zIndex: 1000,
//     },
//     modalContent: {
//       backgroundColor: 'white',
//       borderRadius: '16px',
//       width: '600px',
//       maxHeight: '90vh',
//       overflow: 'auto',
//       boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
//       padding: '2rem',
//     },
//     modalHeader: {
//       backgroundColor: '#2563eb',
//       color: 'white',
//       padding: '1rem 1.5rem',
//       borderRadius: '12px 12px 0 0',
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//     },
//     modalCloseButton: {
//       background: 'none',
//       border: 'none',
//       color: 'white',
//       fontSize: '1.25rem',
//       cursor: 'pointer',
//       padding: '0.25rem',
//     },
//     formSection: {
//       padding: '1.5rem',
//       border: '1px solid #e2e8f0',
//       borderRadius: '8px',
//       marginBottom: '1.5rem',
//       backgroundColor: '#fff',
//       boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
//     },
//     sectionHeading: {
//       fontSize: '1.25rem',
//       fontWeight: '600',
//       marginBottom: '1rem',
//       color: '#1f2937',
//     },
//     inputGroup: {
//       marginBottom: '1rem',
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '0.5rem',
//     },
//     label: {
//       display: 'block',
//       fontSize: '0.875rem',
//       fontWeight: '500',
//       color: '#374151',
//       marginBottom: '0.25rem',
//     },
//     requiredAsterisk: {
//       color: '#ef4444',
//       marginLeft: '0.25rem',
//     },
//     buttonContainer: {
//       marginTop: '2rem',
//       display: 'flex',
//       justifyContent: 'flex-end',
//       gap: '1rem',
//       paddingTop: '1rem',
//       borderTop: '1px solid #e2e8f0',
//     },
//     submitButton: {
//       padding: '0.5rem 1.5rem',
//       borderRadius: '6px',
//       fontWeight: '500',
//       fontSize: '0.875rem',
//       cursor: 'pointer',
//       border: 'none',
//       backgroundColor: '#10b981',
//       color: 'white',
//       transition: 'all 0.2s ease',
//     },
//     cancelButton: {
//       padding: '0.5rem 1.5rem',
//       borderRadius: '6px',
//       fontWeight: '500',
//       fontSize: '0.875rem',
//       cursor: 'pointer',
//       border: 'none',
//       backgroundColor: '#ef4444',
//       color: 'white',
//       transition: 'all 0.2s ease',
//     },
//     editButton: {
//       padding: '0.5rem 1rem',
//       borderRadius: '6px',
//       fontWeight: '500',
//       fontSize: '0.875rem',
//       cursor: 'pointer',
//       border: 'none',
//       backgroundColor: '#f59e0b',
//       color: 'white',
//       transition: 'all 0.2s ease',
//       marginRight: '0.5rem',
//     },
//     deleteButton: {
//       padding: '0.5rem 1rem',
//       borderRadius: '6px',
//       fontWeight: '500',
//       fontSize: '0.875rem',
//       cursor: 'pointer',
//       border: 'none',
//       backgroundColor: '#dc2626',
//       color: 'white',
//       transition: 'all 0.2s ease',
//     },
//     loading: {
//       textAlign: 'center',
//       padding: '4rem',
//       color: '#718096',
//       fontSize: '1.1rem',
//     },
//   };

//   return (
//     <div style={styles.container}>
//       {successMessage && (
//         <div style={styles.messageSuccess}>
//           <span>✅</span>
//           {successMessage}
//         </div>
//       )}
//       {errorMessage && (
//         <div style={styles.messageError}>
//           <span>❌</span>
//           {errorMessage}
//         </div>
//       )}

//       <div style={styles.header}>
        
//         <button
//           onClick={() => setShowAddProductForm(true)}
//           style={styles.button1}
//           onMouseEnter={(e) => {
//             e.target.style.transform = 'translateY(-2px)';
//             e.target.style.boxShadow = '0 6px 20px rgba(37, 99, 235, 0.4)';
//           }}
//           onMouseLeave={(e) => {
//             e.target.style.transform = 'translateY(0)';
//             e.target.style.boxShadow = '0 4px 15px rgba(37, 99, 235, 0.3)';
//           }}
//           disabled={loading}
//         >
//           + New Product
//         </button>
//       </div>

//       {showAddProductForm && (
//         <div style={styles.modal}>
//           <div style={styles.modalContent}>
//             <div style={styles.modalHeader}>
//               <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: '600' }}>Add Product</h3>
//               <button
//                 onClick={() => setShowAddProductForm(false)}
//                 style={styles.modalCloseButton}
//               >
//                 ✕
//               </button>
//             </div>
//             <div style={styles.formSection}>
//               {successMessage && (
//                 <div style={styles.messageSuccess}>
//                   <span>✅</span>
//                   {successMessage}
//                 </div>
//               )}
//               {errorMessage && (
//                 <div style={styles.messageError}>
//                   <span>❌</span>
//                   {errorMessage}
//                 </div>
//               )}
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>
//                   Product Code<span style={styles.requiredAsterisk}>*</span>
//                 </label>
//                 <input
//                   type="text"
//                   value={productForm.productCode}
//                   onChange={(e) => handleProductFormChange("productCode", e.target.value)}
//                   style={styles.input}
//                   placeholder="Enter product code"
//                   required
//                 />
//               </div>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>HSN Code</label>
//                 <input
//                   type="text"
//                   value={productForm.hsnCode}
//                   onChange={(e) => handleProductFormChange("hsnCode", e.target.value)}
//                   style={styles.input}
//                   placeholder="Enter HSN code"
//                 />
//               </div>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>
//                   Product Name<span style={styles.requiredAsterisk}>*</span>
//                 </label>
//                 <input
//                   type="text"
//                   value={productForm.productName}
//                   onChange={(e) => handleProductFormChange("productName", e.target.value)}
//                   style={styles.input}
//                   placeholder="Enter product name"
//                   required
//                 />
//               </div>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>Barcode</label>
//                 <input
//                   type="text"
//                   value={productForm.barcode}
//                   onChange={(e) => handleProductFormChange("barcode", e.target.value)}
//                   style={styles.input}
//                   placeholder="Enter barcode"
//                 />
//               </div>
//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
//                 <div style={styles.inputGroup}>
//                   <label style={styles.label}>Group</label>
//                   <select
//                     value={productForm.group}
//                     onChange={(e) => handleProductFormChange("group", e.target.value)}
//                     style={styles.select}
//                   >
//                     <option value="">SELECT GROUP</option>
//                     {groups.map((group) => (
//                       <option key={group.id} value={group.name}>
//                         {group.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div style={styles.inputGroup}>
//                   <label style={styles.label}>Category</label>
//                   <select
//                     value={productForm.category}
//                     onChange={(e) => handleProductFormChange("category", e.target.value)}
//                     style={styles.select}
//                   >
//                     <option value="">SELECT CATEGORY</option>
//                     {categories.map((category) => (
//                       <option key={category.id} value={category.name}>
//                         {category.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
//                 <div style={styles.inputGroup}>
//                   <label style={styles.label}>Brand</label>
//                   <select
//                     value={productForm.brand}
//                     onChange={(e) => handleProductFormChange("brand", e.target.value)}
//                     style={styles.select}
//                   >
//                     <option value="">SELECT BRAND</option>
//                     {brands.map((brand) => (
//                       <option key={brand.id} value={brand.name}>
//                         {brand.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div style={styles.inputGroup}>
//                   <label style={styles.label}>
//                     UOM<span style={styles.requiredAsterisk}>*</span>
//                   </label>
//                   <select
//                     value={productForm.uom}
//                     onChange={(e) => handleProductFormChange("uom", e.target.value)}
//                     style={styles.select}
//                     required
//                   >
//                     <option value="">SELECT UOM</option>
//                     {units.map((unit) => (
//                       <option key={unit.id} value={unit.name}>
//                         {unit.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
//                 <div style={styles.inputGroup}>
//                   <label style={styles.label}>MRP</label>
//                   <input
//                     type="number"
//                     value={productForm.mrp}
//                     onChange={(e) => handleProductFormChange("mrp", e.target.value)}
//                     style={styles.input}
//                     placeholder="0.00"
//                     min="0"
//                     step="0.01"
//                   />
//                 </div>
//                 <div style={styles.inputGroup}>
//                   <label style={styles.label}>Selling Price</label>
//                   <input
//                     type="number"
//                     value={productForm.sellingPrice}
//                     onChange={(e) => handleProductFormChange("sellingPrice", e.target.value)}
//                     style={styles.input}
//                     placeholder="0.00"
//                     min="0"
//                     step="0.01"
//                   />
//                 </div>
//               </div>
//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
//                 <div style={styles.inputGroup}>
//                   <label style={styles.label}>Purchase Tax</label>
//                   <select
//                     value={productForm.purchaseTax}
//                     onChange={(e) => handleProductFormChange("purchaseTax", e.target.value)}
//                     style={styles.select}
//                   >
//                     <option value="0">0%</option>
//                     <option value="5">5%</option>
//                     <option value="12">12%</option>
//                     <option value="18">18%</option>
//                     <option value="28">28%</option>
//                   </select>
//                 </div>
//                 <div style={styles.inputGroup}>
//                   <label style={styles.label}>Sales Tax</label>
//                   <select
//                     value={productForm.salesTax}
//                     onChange={(e) => handleProductFormChange("salesTax", e.target.value)}
//                     style={styles.select}
//                   >
//                     <option value="0">0%</option>
//                     <option value="5">5%</option>
//                     <option value="12">12%</option>
//                     <option value="18">18%</option>
//                     <option value="28">28%</option>
//                   </select>
//                 </div>
//               </div>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>Style No</label>
//                 <input
//                   type="text"
//                   value={productForm.styleNo}
//                   onChange={(e) => handleProductFormChange("styleNo", e.target.value)}
//                   style={styles.input}
//                   placeholder="Enter style number"
//                 />
//               </div>
//               <div style={styles.buttonContainer}>
//                 <button
//                   onClick={() => setShowAddProductForm(false)}
//                   style={styles.cancelButton}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={addProduct}
//                   style={styles.submitButton}
//                 >
//                   Add Product
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem', marginBottom: '2rem' }}>
//     <div style={styles.inputGroup}>
//   <label style={styles.label}>Ref No</label>
//   <input
//     type="number"
//     value={refNo}
//     readOnly
//     style={{ ...styles.input, ...styles.disabledInput }}
//   />
// </div>
//         <div style={styles.inputGroup}>
//           <label style={styles.label}>Ref Date</label>
//           <input
//             type="date"
//             value={refDate}
//             onChange={(e) => setRefDate(e.target.value)}
//             style={styles.input}
//           />
//         </div>
//         <div style={styles.inputGroup}>
//           <label style={styles.label}>Account</label>
//           <select value={account} onChange={(e) => setAccount(e.target.value)} style={styles.select}>
//             <option value="OPENING STOCK">OPENING STOCK</option>
//             <option value="OTHER">OTHER</option>
//           </select>
//         </div>
//         <div style={styles.inputGroup}>
//           <label style={styles.label}>Branch</label>
//           <select value={branch} onChange={(e) => setBranch(e.target.value)} style={styles.select}>
//             {branchProfile ? (
//               <option value={branchProfile.branchName}>{branchProfile.branchName}</option>
//             ) : (
//               <option value="">Loading branch...</option>
//             )}
//             <option value="OTHER">OTHER</option>
//           </select>
//         </div>
//         <div style={styles.inputGroup}>
//           <label style={styles.label}>Location</label>
//           <select value={location} onChange={(e) => setLocation(e.target.value)} style={styles.select}>
//             <option value="WAREHOUSE">WAREHOUSE</option>
//             <option value="OTHER">OTHER</option>
//           </select>
//         </div>
//       </div>

//       {loading ? (
//         <div style={styles.loading}>⏳ Loading...</div>
//       ) : (
//         <div style={styles.tableContainer}>
//           <table style={styles.table}>
//             <thead>
//               <tr>
//                 <th style={styles.th}>S NO</th>
//                 <th style={styles.th}>ITEM DESCRIPTION</th>
//                 <th style={styles.th}>UOM</th>
//                 <th style={styles.th}>QTY (TAQ)</th>
//                 <th style={styles.th}>TAX (%)</th>
//                 <th style={styles.th}>TAX AMT</th>
//                 <th style={styles.th}>MRP</th>
//                 <th style={styles.th}>VALUE</th>
//               </tr>
//             </thead>
//             <tbody>
//               {items.map((item, index) => (
//                 <tr
//                   key={index}
//                   style={{
//                     backgroundColor: index % 2 === 0 ? '#f7fafc' : 'white',
//                     transition: 'background-color 0.2s ease',
//                   }}
//                 >
//                   <td style={{ ...styles.td, textAlign: 'center', fontWeight: '600', color: '#2563eb' }}>
//                     {index + 1}
//                   </td>
//                   <td style={styles.td}>
//                     <div style={{ position: 'relative' }}>
//                       <input
//                         type="text"
//                         value={item.itemDescription}
//                         onChange={(e) => handleItemChange(index, "itemDescription", e.target.value)}
//                         onKeyDown={(e) => handleKeyDown(e, index)}
//                         style={styles.input}
//                         placeholder="Search product..."
//                       />
//                       {focusedItemIndex === index && suggestions.length > 0 && (
//                         <div style={styles.suggestions}>
//                           <table style={styles.suggestionTable}>
//                             <thead>
//                               <tr>
//                                 <th style={styles.suggestionTh}>CODE</th>
//                                 <th style={styles.suggestionTh}>PRODUCT</th>
//                                 <th style={styles.suggestionTh}>RACK</th>
//                                 <th style={styles.suggestionTh}>BRAND</th>
//                                 <th style={styles.suggestionTh}>S.PRICE</th>
//                                 <th style={styles.suggestionTh}>QTY</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {suggestions.map((product, idx) => (
//                                 <tr
//                                   key={product.id}
//                                   ref={(el) => (suggestionRefs.current[idx] = el)}
//                                   style={{
//                                     ...styles.suggestionItem,
//                                     ...(activeSuggestionIndex === idx ? styles.suggestionActive : {}),
//                                   }}
//                                   onClick={() => handleSelect(index, product)}
//                                   onMouseEnter={() => setActiveSuggestionIndex(idx)}
//                                 >
//                                   <td style={styles.suggestionTd}>{products.findIndex(p => p.id === product.id) + 1}</td>
//                                   <td style={styles.suggestionTd}>{product.productName || 'Unknown Product'}</td>
//                                   <td style={styles.suggestionTd}>{product.rack || 'N/A'}</td>
//                                   <td style={styles.suggestionTd}>{product.brand || 'GENERAL'}</td>
//                                   <td style={styles.suggestionTd}>₹{parseFloat(product.sellingPrice || 0).toFixed(2)}</td>
//                                   <td style={styles.suggestionTd}>{product.openingStock || '0'}</td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       )}
//                     </div>
//                   </td>
//                   <td style={styles.td}>
//                     <input
//                       type="text"
//                       value={item.uom}
//                       onChange={(e) => handleItemChange(index, "uom", e.target.value)}
//                       style={{ ...styles.input, ...styles.disabledInput }}
//                       disabled
//                     />
//                   </td>
//                   <td style={styles.td}>
//                     <input
//                       type="number"
//                       value={item.qty}
//                       onChange={(e) => handleItemChange(index, "qty", e.target.value)}
//                       style={styles.input}
//                       min="0"
//                     />
//                   </td>
//                   <td style={styles.td}>
//                     <input
//                       type="number"
//                       value={item.tax}
//                       onChange={(e) => handleItemChange(index, "tax", e.target.value)}
//                       style={{ ...styles.input, ...styles.disabledInput }}
//                       disabled
//                     />
//                   </td>
//                   <td style={styles.td}>
//                     <input
//                       type="number"
//                       value={item.taxAmount}
//                       style={{ ...styles.input, ...styles.disabledInput }}
//                       disabled
//                     />
//                   </td>
//                   <td style={styles.td}>
//                     <input
//                       type="number"
//                       value={item.mrp}
//                       onChange={(e) => handleItemChange(index, "mrp", e.target.value)}
//                       style={{ ...styles.input, ...styles.disabledInput }}
//                       disabled
//                     />
//                   </td>
//                   <td style={styles.td}>
//                     <input
//                       type="number"
//                       value={item.value}
//                       style={{ ...styles.input, ...styles.disabledInput }}
//                       disabled
//                     />
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       <div style={styles.buttonContainer}>
//         <button
//           onClick={addNewLine}
//           style={styles.button}
//           disabled={loading}
//           onMouseEnter={(e) => {
//             e.target.style.transform = 'translateY(-2px)';
//             e.target.style.boxShadow = '0 6px 20px rgba(37, 99, 235, 0.4)';
//           }}
//           onMouseLeave={(e) => {
//             e.target.style.transform = 'translateY(0)';
//             e.target.style.boxShadow = '0 4px 15px rgba(37, 99, 235, 0.3)';
//           }}
//         >
//           + New Line
//         </button>
//         <button
//           onClick={saveToFirestore}
//           style={styles.submitButton}
//           disabled={loading}
//         >
//           {initialData?.id ? 'Update' : 'Save'}
//         </button>
//         <button
//           onClick={cancel}
//           style={styles.cancelButton}
//           disabled={loading}
//         >
//           Cancel
//         </button>
//       </div>

//       <style jsx>{`
//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }
//         input:focus, select:focus {
//           outline: none;
//           border-color: #2563eb;
//           box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
//         }
//         input:hover, select:hover {
//           border-color: #a1a1aa;
//         }
//         button:hover:not(:disabled) {
//           filter: brightness(90%);
//         }
//         @media (max-width: 768px) {
//           .container {
//             padding: 1rem;
//           }
//           .header {
//             flex-direction: column;
//             gap: 1rem;
//           }
//           .buttonContainer {
//             flex-direction: column;
//           }
//           .button,
//           .submitButton,
//           .cancelButton {
//             width: 100%;
//             justify-content: center;
//           }
//           .modalContent {
//             width: 90%;
//             padding: 1rem;
//           }
//           .inputGroup {
//             grid-template-columns: 1fr;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default OpeningStock;


// import React, { useState, useEffect, useRef } from "react";
// import { getDatabase, ref, push, set, onValue, off, update, get } from "firebase/database";
// import { auth } from "../firebase";
// import { onAuthStateChanged } from "firebase/auth";

// const OpeningStock = ({ onSuccess, onCancel, initialData }) => {
//   const [items, setItems] = useState(
//     initialData?.items || [
//       { itemDescription: "", uom: "", qty: "", tax: "", taxAmount: "", mrp: "", value: "" },
//     ]
//   );
//   const [account, setAccount] = useState(initialData?.account || "OPENING STOCK");
//   const [branch, setBranch] = useState(initialData?.branch || "");
//   const [location, setLocation] = useState(initialData?.location || "WAREHOUSE");
//   const [refNo, setRefNo] = useState(initialData?.refNo || 1);
//   const [refDate, setRefDate] = useState(
//     initialData?.refDate || new Date().toISOString().split('T')[0]
//   );
//   const [showAddProductForm, setShowAddProductForm] = useState(false);
//   const [productForm, setProductForm] = useState({
//     productCode: "",
//     hsnCode: "",
//     productName: "",
//     barcode: "",
//     group: "",
//     category: "",
//     brand: "",
//     uom: "",
//     mrp: "",
//     sellingPrice: "",
//     purchaseTax: "0",
//     salesTax: "0",
//     styleNo: "",
//   });
//   const [currentUser, setCurrentUser] = useState(null);
//   const [groups, setGroups] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [brands, setBrands] = useState([]);
//   const [units, setUnits] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [branches, setBranches] = useState([]); // Added state for branches
//   const [branchProfile, setBranchProfile] = useState(null);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [successMessage, setSuccessMessage] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [suggestions, setSuggestions] = useState([]);
//   const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(-1);
//   const [focusedItemIndex, setFocusedItemIndex] = useState(null);
//   const suggestionRefs = useRef([]);

//   const database = getDatabase();

//   const encodeEmailForPath = (email) => {
//     if (!email) return "";
//     return email.replace(/[.#$[\]]/g, "_");
//   };

//   // Fetch current user
//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       setCurrentUser(user);
//       setLoading(false);
//     });
//     return () => unsubscribe();
//   }, []);

//   // Fetch max Ref No
//   useEffect(() => {
//     if (!currentUser || initialData) return;

//     const encodedEmail = encodeEmailForPath(currentUser.email);
//     const stockRef = ref(database, `users/${encodedEmail}/openingStock`);
//     get(stockRef)
//       .then((snapshot) => {
//         let maxRefNo = 0;
//         if (snapshot.exists()) {
//           const stockEntries = snapshot.val();
//           const refNos = Object.values(stockEntries)
//             .map((entry) => parseInt(entry.refNo, 10))
//             .filter((num) => !isNaN(num));
//           maxRefNo = refNos.length > 0 ? Math.max(...refNos) : 0;
//         }
//         setRefNo(maxRefNo + 1 || 1);
//       })
//       .catch((error) => {
//         console.error('Error fetching Ref No:', error);
//         setErrorMessage('Failed to fetch Ref No.');
//       });
//   }, [currentUser, initialData]);

//   // Fetch groups, categories, brands, units, products, branches, and branch profile
//   useEffect(() => {
//     if (!currentUser || !currentUser.email) return;

//     setLoading(true);
//     const encodedEmail = encodeEmailForPath(currentUser.email);
//     if (!encodedEmail) {
//       setErrorMessage("Invalid user email. Cannot fetch data.");
//       setLoading(false);
//       return;
//     }

//     const groupsRef = ref(database, `users/${encodedEmail}/productGroups`);
//     const categoriesRef = ref(database, `users/${encodedEmail}/categories`);
//     const brandsRef = ref(database, `users/${encodedEmail}/brands`);
//     const unitsRef = ref(database, `users/${encodedEmail}/units`);
//     const productsRef = ref(database, `users/${encodedEmail}/products`);
//     const branchesRef = ref(database, `users/${encodedEmail}/branches`); // Added branches reference
//     const branchProfileRef = ref(database, `users/${encodedEmail}/branchProfiles`);

//     const listeners = [
//       { ref: groupsRef, setData: setGroups },
//       { ref: categoriesRef, setData: setCategories },
//       { ref: brandsRef, setData: setBrands },
//       { ref: unitsRef, setData: setUnits },
//       { ref: productsRef, setData: setProducts },
//       { ref: branchesRef, setData: setBranches }, // Added branches listener
//     ];

//     listeners.forEach(({ ref, setData }) => {
//       onValue(
//         ref,
//         (snapshot) => {
//           const data = [];
//           snapshot.forEach((childSnapshot) => {
//             data.push({ id: childSnapshot.key, ...childSnapshot.val() });
//           });
//           setData(data);
//         },
//         (error) => {
//           console.error(`Error fetching data:`, error);
//           setErrorMessage(`Failed to load data: ${error.message}`);
//         }
//       );
//     });

//     // Fetch branch profile
//     onValue(
//       branchProfileRef,
//       (snapshot) => {
//         const data = snapshot.val();
//         if (data) {
//           const profiles = Object.values(data);
//           if (profiles.length > 0) {
//             const latestProfile = profiles[profiles.length - 1];
//             setBranchProfile(latestProfile);
//             if (!initialData) {
//               setBranch(latestProfile.branchName || "WAREHOUSE");
//             }
//           }
//         }
//         setLoading(false);
//       },
//       (error) => {
//         console.error("Error fetching branch profile:", error);
//         setErrorMessage(`Failed to load branch profile: ${error.message}`);
//         setLoading(false);
//       }
//     );

//     return () => {
//       listeners.forEach(({ ref }) => off(ref));
//       off(branchProfileRef);
//     };
//   }, [currentUser, initialData]);

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (
//         suggestionRefs.current.every((ref) => ref && !ref.contains(e.target)) &&
//         !e.target.closest('input')
//       ) {
//         setSuggestions([]);
//         setFocusedItemIndex(null);
//         setActiveSuggestionIndex(-1);
//       }
//     };

//     document.addEventListener('click', handleClickOutside);
//     return () => document.removeEventListener('click', handleClickOutside);
//   }, []);

//   // Handle item changes
//   const handleItemChange = (index, field, value) => {
//     const updatedItems = [...items];
//     if (field === "itemDescription") {
//       updatedItems[index][field] = value;
//       if (value.trim()) {
//         const filtered = products.filter((p) =>
//           p.productName && p.productName.toLowerCase().includes(value.toLowerCase())
//         );
//         setSuggestions(filtered.slice(0, 5));
//         setFocusedItemIndex(index);
//         setActiveSuggestionIndex(-1);
//       } else {
//         setSuggestions([]);
//         setFocusedItemIndex(null);
//       }
//     } else {
//       updatedItems[index][field] = value;
//     }

//     if (field === "qty" || field === "tax" || field === "mrp") {
//       const qty = parseFloat(updatedItems[index].qty) || 0;
//       const tax = parseFloat(updatedItems[index].tax) || 0;
//       const mrp = parseFloat(updatedItems[index].mrp) || 0;

//       const taxAmount = (mrp * qty * tax) / 100;
//       const value = mrp * qty + taxAmount;

//       updatedItems[index].taxAmount = taxAmount.toFixed(2);
//       updatedItems[index].value = value.toFixed(2);
//     }

//     setItems(updatedItems);
//   };

//   const handleSelect = (index, product) => {
//     const updatedItems = [...items];
//     updatedItems[index] = {
//       itemDescription: product.productName || "",
//       uom: product.uom || product.unit || "",
//       qty: updatedItems[index].qty || "",
//       tax: product.salesTax || "0",
//       taxAmount: "",
//       mrp: product.mrp || "0",
//       value: "",
//     };
//     const qty = parseFloat(updatedItems[index].qty) || 0;
//     const tax = parseFloat(updatedItems[index].tax) || 0;
//     const mrp = parseFloat(updatedItems[index].mrp) || 0;
//     const taxAmount = (mrp * qty * tax) / 100;
//     const value = mrp * qty + taxAmount;
//     updatedItems[index].taxAmount = taxAmount.toFixed(2);
//     updatedItems[index].value = value.toFixed(2);
//     setItems(updatedItems);
//     setSuggestions([]);
//     setFocusedItemIndex(null);
//     setActiveSuggestionIndex(-1);
//   };

//   const handleKeyDown = (e, index) => {
//     if (focusedItemIndex !== index || suggestions.length === 0) return;

//     if (e.key === 'ArrowDown') {
//       e.preventDefault();
//       setActiveSuggestionIndex((prev) =>
//         prev < suggestions.length - 1 ? prev + 1 : prev
//       );
//     } else if (e.key === 'ArrowUp') {
//       e.preventDefault();
//       setActiveSuggestionIndex((prev) => (prev > 0 ? prev - 1 : prev));
//     } else if (e.key === 'Enter' && activeSuggestionIndex >= 0) {
//       e.preventDefault();
//       handleSelect(index, suggestions[activeSuggestionIndex]);
//     } else if (e.key === 'Escape') {
//       setSuggestions([]);
//       setFocusedItemIndex(null);
//       setActiveSuggestionIndex(-1);
//     }
//   };

//   const addNewLine = () => {
//     setItems([
//       ...items,
//       { itemDescription: "", uom: "", qty: "", tax: "", taxAmount: "", mrp: "", value: "" },
//     ]);
//   };

//   const saveToFirestore = async () => {
//     setErrorMessage("");
//     setSuccessMessage("");
//     if (!currentUser || !currentUser.email) {
//       setErrorMessage("You must be logged in with a valid email to save data!");
//       return;
//     }

//     const encodedEmail = encodeEmailForPath(currentUser.email);
//     try {
//       const nonEmptyItems = items.filter(
//         (item) =>
//           item.itemDescription.trim() !== "" &&
//           item.qty !== "" &&
//           item.mrp !== "" &&
//           !isNaN(parseFloat(item.qty)) &&
//           !isNaN(parseFloat(item.mrp))
//       );

//       if (nonEmptyItems.length === 0) {
//         setErrorMessage("Please add at least one valid item with product, quantity, and MRP!");
//         return;
//       }

//       const stockData = {
//         refNo,
//         refDate,
//         account,
//         branch,
//         location,
//         items: nonEmptyItems,
//         createdAt: new Date().toISOString(),
//       };

//       if (initialData?.id) {
//         // Update existing stock entry
//         const stockRef = ref(database, `users/${encodedEmail}/openingStock/${initialData.id}`);
//         // Revert previous stock quantities
//         const oldStock = initialData.items || [];
//         for (const item of oldStock) {
//           const product = products.find(p => p.productName === item.itemDescription);
//           if (product) {
//             const qty = parseFloat(item.qty) || 0;
//             const currentStock = parseFloat(product.openingStock) || 0;
//             const newStock = currentStock - qty;
//             const productRef = ref(database, `users/${encodedEmail}/products/${product.id}`);
//             await update(productRef, { openingStock: newStock.toString() });
//           }
//         }
//         // Update with new data
//         await update(stockRef, stockData);
//         // Update product stock for new items
//         for (const item of nonEmptyItems) {
//           const product = products.find(p => p.productName === item.itemDescription);
//           if (product) {
//             const qty = parseFloat(item.qty);
//             const currentStock = parseFloat(product.openingStock) || 0;
//             const newStock = currentStock + qty;
//             const productRef = ref(database, `users/${encodedEmail}/products/${product.id}`);
//             await update(productRef, { openingStock: newStock.toString() });
//           }
//         }
//         setSuccessMessage("Stock updated successfully!");
//       } else {
//         // Create new stock entry
//         const newStockRef = push(ref(database, `users/${encodedEmail}/openingStock`));
//         await set(newStockRef, stockData);
//         // Update product opening stock
//         for (const item of nonEmptyItems) {
//           const product = products.find(p => p.productName === item.itemDescription);
//           if (product) {
//             const qty = parseFloat(item.qty);
//             const currentStock = parseFloat(product.openingStock) || 0;
//             const newStock = currentStock + qty;
//             const productRef = ref(database, `users/${encodedEmail}/products/${product.id}`);
//             await update(productRef, { openingStock: newStock.toString() });
//           }
//         }
//         setSuccessMessage("Data saved successfully!");
//       }

//       onSuccess();
//     } catch (error) {
//       console.error("Error saving data:", error);
//       setErrorMessage(`Failed to save data: ${error.message}`);
//     }
//   };

//   const handleProductFormChange = (field, value) => {
//     setProductForm((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   const addProduct = async () => {
//     setErrorMessage("");
//     setSuccessMessage("");
//     if (!currentUser || !currentUser.email) {
//       setErrorMessage("You must be logged in with a valid email to add a product!");
//       return;
//     }

//     const encodedEmail = encodeEmailForPath(currentUser.email);
//     try {
//       if (!productForm.productName || !productForm.uom) {
//         setErrorMessage("Please fill all required fields (Product Name, UOM)!");
//         return;
//       }

//       const productData = {
//         ...productForm,
//         createdAt: new Date().toISOString(),
//         createdBy: currentUser.email,
//         mrp: parseFloat(productForm.mrp) || 0,
//         sellingPrice: parseFloat(productForm.sellingPrice) || 0,
//         purchaseTax: parseFloat(productForm.purchaseTax) || 0,
//         salesTax: parseFloat(productForm.salesTax) || 0,
//         openingStock: "0",
//       };

//       const newProductRef = push(ref(database, `users/${encodedEmail}/products`));
//       await set(newProductRef, productData);

//       setSuccessMessage("Product added successfully!");
//       setShowAddProductForm(false);
//       setProductForm({
//         productCode: "",
//         hsnCode: "",
//         productName: "",
//         barcode: "",
//         group: "",
//         category: "",
//         brand: "",
//         uom: "",
//         mrp: "",
//         sellingPrice: "",
//         purchaseTax: "0",
//         salesTax: "0",
//         styleNo: "",
//       });
//     } catch (error) {
//       console.error("Error adding product:", error);
//       setErrorMessage(`Failed to add product: ${error.message}`);
//     }
//   };

//   const cancel = () => {
//     setItems([{ itemDescription: "", uom: "", qty: "", tax: "", taxAmount: "", mrp: "", value: "" }]);
//     setAccount("OPENING STOCK");
//     setBranch(branchProfile?.branchName || "WAREHOUSE");
//     setLocation("WAREHOUSE");
//     setRefDate(new Date().toISOString().split('T')[0]);
//     setErrorMessage("");
//     setSuccessMessage("");
//     setShowAddProductForm(false);
//     onCancel();
//   };

//   // Styles
//   const styles = {
//     container: {
//       maxWidth: '1200px',
//       margin: '0 auto',
//       padding: '2rem',
//       backgroundColor: 'white',
//       minHeight: '100vh',
//       fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
//     },
//     header: {
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       marginBottom: '2rem',
//       padding: '1.5rem',
//     },
//     heading: {
//       fontSize: '2rem',
//       fontWeight: '700',
//       color: '#2563eb',
//       margin: '0',
//     },
//     button: {
//       padding: '0.875rem 2rem',
//       borderRadius: '8px',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '600',
//       cursor: 'pointer',
//       border: 'none',
//       fontSize: '0.95rem',
//       transition: 'all 0.3s ease',
//       boxShadow: '0 4px 15px rgba(37, 99, 235, 0.3)',
//       transform: 'translateY(0)',
//     },
//     button1: {
//       padding: '0.875rem 2rem',
//       borderRadius: '8px',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '600',
//       cursor: 'pointer',
//       border: 'none',
//       fontSize: '0.95rem',
//       transition: 'all 0.3s ease',
//       boxShadow: '0 4px 15px rgba(37, 99, 235, 0.3)',
//       transform: 'translateY(0)',
//       marginLeft: '900px',
//     },
//     tableContainer: {
//       backgroundColor: 'white',
//       borderRadius: '16px',
//       boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
//       border: '1px solid #e2e8f0',
//       marginBottom: '2rem',
//     },
//     table: {
//       width: '100%',
//       borderCollapse: 'collapse',
//       fontSize: '0.9rem',
//       border: '1px solid #d1d5db',
//     },
//     th: {
//       padding: '1rem 0.75rem',
//       textAlign: 'left',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '600',
//       fontSize: '0.85rem',
//       textTransform: 'uppercase',
//       letterSpacing: '0.5px',
//       border: '1px solid #1e40af',
//     },
//     td: {
//       padding: '1rem 0.75rem',
//       border: '1px solid #d1d5db',
//       color: '#374151',
//       verticalAlign: 'middle',
//     },
//     input: {
//       display: 'block',
//       width: '80%',
//       padding: '0.5rem 0.75rem',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       fontSize: '0.875rem',
//       backgroundColor: '#fff',
//       transition: 'border-color 0.2s ease',
//     },
//     select: {
//       display: 'block',
//       width: '100%',
//       padding: '0.5rem 0.75rem',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       fontSize: '0.875rem',
//       backgroundColor: '#fff',
//       cursor: 'pointer',
//       appearance: 'none',
//       backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e")`,
//       backgroundPosition: 'right 0.5rem center',
//       backgroundRepeat: 'no-repeat',
//       backgroundSize: '1em 1em',
//       paddingRight: '2rem',
//     },
//     disabledInput: {
//       backgroundColor: '#f3f4f6',
//       cursor: 'not-allowed',
//     },
//     suggestions: {
//       position: 'absolute',
//       top: '100%',
//       left: '0',
//       width: '100%',
//       backgroundColor: '#ffffff',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       zIndex: 1000,
//       maxHeight: '300px',
//       boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
//     },
//     suggestionTable: {
//       width: '100%',
//       borderCollapse: 'collapse',
//     },
//     suggestionTh: {
//       padding: '0.5rem',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '600',
//       fontSize: '0.7rem',
//       textAlign: 'center',
//       border: '1px solid #1e40af',
//     },
//     suggestionTd: {
//       padding: '0.5rem',
//       border: '1px solid #e2e8f0',
//       fontSize: '0.75rem',
//       textAlign: 'center',
//     },
//     suggestionItem: {
//       cursor: 'pointer',
//       transition: 'background-color 0.2s ease',
//     },
//     suggestionActive: {
//       backgroundColor: '#e0f2fe',
//     },
//     messageSuccess: {
//       padding: '1rem 1.5rem',
//       marginBottom: '1.5rem',
//       borderRadius: '12px',
//       backgroundColor: '#d1fae5',
//       color: '#065f46',
//       border: '1px solid #a7f3d0',
//       fontSize: '0.9rem',
//       fontWeight: '500',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '0.5rem',
//     },
//     messageError: {
//       padding: '1rem 1.5rem',
//       marginBottom: '1.5rem',
//       borderRadius: '12px',
//       backgroundColor: '#fee2e2',
//       color: '#b91c1c',
//       border: '1px solid #fecaca',
//       fontSize: '0.9rem',
//       fontWeight: '500',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '0.5rem',
//     },
//     modal: {
//       position: 'fixed',
//       top: '0',
//       left: '0',
//       right: '0',
//       bottom: '0',
//       backgroundColor: 'rgba(0,0,0,0.5)',
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       zIndex: 1000,
//     },
//     modalContent: {
//       backgroundColor: 'white',
//       borderRadius: '16px',
//       width: '600px',
//       maxHeight: '90vh',
//       overflow: 'auto',
//       boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
//       padding: '2rem',
//     },
//     modalHeader: {
//       backgroundColor: '#2563eb',
//       color: 'white',
//       padding: '1rem 1.5rem',
//       borderRadius: '12px 12px 0 0',
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//     },
//     modalCloseButton: {
//       background: 'none',
//       border: 'none',
//       color: 'white',
//       fontSize: '1.25rem',
//       cursor: 'pointer',
//       padding: '0.25rem',
//     },
//     formSection: {
//       padding: '1.5rem',
//       border: '1px solid #e2e8f0',
//       borderRadius: '8px',
//       marginBottom: '1.5rem',
//       backgroundColor: '#fff',
//       boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
//     },
//     sectionHeading: {
//       fontSize: '1.25rem',
//       fontWeight: '600',
//       marginBottom: '1rem',
//       color: '#1f2937',
//     },
//     inputGroup: {
//       marginBottom: '1rem',
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '0.5rem',
//     },
//     label: {
//       display: 'block',
//       fontSize: '0.875rem',
//       fontWeight: '500',
//       color: '#374151',
//       marginBottom: '0.25rem',
//     },
//     requiredAsterisk: {
//       color: '#ef4444',
//       marginLeft: '0.25rem',
//     },
//     buttonContainer: {
//       marginTop: '2rem',
//       display: 'flex',
//       justifyContent: 'flex-end',
//       gap: '1rem',
//       paddingTop: '1rem',
//       borderTop: '1px solid #e2e8f0',
//     },
//     submitButton: {
//       padding: '0.5rem 1.5rem',
//       borderRadius: '6px',
//       fontWeight: '500',
//       fontSize: '0.875rem',
//       cursor: 'pointer',
//       border: 'none',
//       backgroundColor: '#10b981',
//       color: 'white',
//       transition: 'all 0.2s ease',
//     },
//     cancelButton: {
//       padding: '0.5rem 1.5rem',
//       borderRadius: '6px',
//       fontWeight: '500',
//       fontSize: '0.875rem',
//       cursor: 'pointer',
//       border: 'none',
//       backgroundColor: '#ef4444',
//       color: 'white',
//       transition: 'all 0.2s ease',
//     },
//     editButton: {
//       padding: '0.5rem 1rem',
//       borderRadius: '6px',
//       fontWeight: '500',
//       fontSize: '0.875rem',
//       cursor: 'pointer',
//       border: 'none',
//       backgroundColor: '#f59e0b',
//       color: 'white',
//       transition: 'all 0.2s ease',
//       marginRight: '0.5rem',
//     },
//     deleteButton: {
//       padding: '0.5rem 1rem',
//       borderRadius: '6px',
//       fontWeight: '500',
//       fontSize: '0.875rem',
//       cursor: 'pointer',
//       border: 'none',
//       backgroundColor: '#dc2626',
//       color: 'white',
//       transition: 'all 0.2s ease',
//     },
//     loading: {
//       textAlign: 'center',
//       padding: '4rem',
//       color: '#718096',
//       fontSize: '1.1rem',
//     },
//   };

//   return (
//     <div style={styles.container}>
//       {successMessage && (
//         <div style={styles.messageSuccess}>
//           <span>✅</span>
//           {successMessage}
//         </div>
//       )}
//       {errorMessage && (
//         <div style={styles.messageError}>
//           <span>❌</span>
//           {errorMessage}
//         </div>
//       )}

//       <div style={styles.header}>
//         <h2 style={styles.heading}>Opening Stock</h2>
//         <button
//           onClick={() => setShowAddProductForm(true)}
//           style={styles.button1}
//           onMouseEnter={(e) => {
//             e.target.style.transform = 'translateY(-2px)';
//             e.target.style.boxShadow = '0 6px 20px rgba(37, 99, 235, 0.4)';
//           }}
//           onMouseLeave={(e) => {
//             e.target.style.transform = 'translateY(0)';
//             e.target.style.boxShadow = '0 4px 15px rgba(37, 99, 235, 0.3)';
//           }}
//           disabled={loading}
//         >
//           + New Product
//         </button>
//       </div>

//       {showAddProductForm && (
//         <div style={styles.modal}>
//           <div style={styles.modalContent}>
//             <div style={styles.modalHeader}>
//               <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: '600' }}>Add Product</h3>
//               <button
//                 onClick={() => setShowAddProductForm(false)}
//                 style={styles.modalCloseButton}
//               >
//                 ✕
//               </button>
//             </div>
//             <div style={styles.formSection}>
//               {successMessage && (
//                 <div style={styles.messageSuccess}>
//                   <span>✅</span>
//                   {successMessage}
//                 </div>
//               )}
//               {errorMessage && (
//                 <div style={styles.messageError}>
//                   <span>❌</span>
//                   {errorMessage}
//                 </div>
//               )}
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>
//                   Product Code<span style={styles.requiredAsterisk}>*</span>
//                 </label>
//                 <input
//                   type="text"
//                   value={productForm.productCode}
//                   onChange={(e) => handleProductFormChange("productCode", e.target.value)}
//                   style={styles.input}
//                   placeholder="Enter product code"
//                   required
//                 />
//               </div>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>HSN Code</label>
//                 <input
//                   type="text"
//                   value={productForm.hsnCode}
//                   onChange={(e) => handleProductFormChange("hsnCode", e.target.value)}
//                   style={styles.input}
//                   placeholder="Enter HSN code"
//                 />
//               </div>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>
//                   Product Name<span style={styles.requiredAsterisk}>*</span>
//                 </label>
//                 <input
//                   type="text"
//                   value={productForm.productName}
//                   onChange={(e) => handleProductFormChange("productName", e.target.value)}
//                   style={styles.input}
//                   placeholder="Enter product name"
//                   required
//                 />
//               </div>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>Barcode</label>
//                 <input
//                   type="text"
//                   value={productForm.barcode}
//                   onChange={(e) => handleProductFormChange("barcode", e.target.value)}
//                   style={styles.input}
//                   placeholder="Enter barcode"
//                 />
//               </div>
//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
//                 <div style={styles.inputGroup}>
//                   <label style={styles.label}>Group</label>
//                   <select
//                     value={productForm.group}
//                     onChange={(e) => handleProductFormChange("group", e.target.value)}
//                     style={styles.select}
//                   >
//                     <option value="">SELECT GROUP</option>
//                     {groups.map((group) => (
//                       <option key={group.id} value={group.name}>
//                         {group.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div style={styles.inputGroup}>
//                   <label style={styles.label}>Category</label>
//                   <select
//                     value={productForm.category}
//                     onChange={(e) => handleProductFormChange("category", e.target.value)}
//                     style={styles.select}
//                   >
//                     <option value="">SELECT CATEGORY</option>
//                     {categories.map((category) => (
//                       <option key={category.id} value={category.name}>
//                         {category.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
//                 <div style={styles.inputGroup}>
//                   <label style={styles.label}>Brand</label>
//                   <select
//                     value={productForm.brand}
//                     onChange={(e) => handleProductFormChange("brand", e.target.value)}
//                     style={styles.select}
//                   >
//                     <option value="">SELECT BRAND</option>
//                     {brands.map((brand) => (
//                       <option key={brand.id} value={brand.name}>
//                         {brand.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div style={styles.inputGroup}>
//                   <label style={styles.label}>
//                     UOM<span style={styles.requiredAsterisk}>*</span>
//                   </label>
//                   <select
//                     value={productForm.uom}
//                     onChange={(e) => handleProductFormChange("uom", e.target.value)}
//                     style={styles.select}
//                     required
//                   >
//                     <option value="">SELECT UOM</option>
//                     {units.map((unit) => (
//                       <option key={unit.id} value={unit.name}>
//                         {unit.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
//                 <div style={styles.inputGroup}>
//                   <label style={styles.label}>MRP</label>
//                   <input
//                     type="number"
//                     value={productForm.mrp}
//                     onChange={(e) => handleProductFormChange("mrp", e.target.value)}
//                     style={styles.input}
//                     placeholder="0.00"
//                     min="0"
//                     step="0.01"
//                   />
//                 </div>
//                 <div style={styles.inputGroup}>
//                   <label style={styles.label}>Selling Price</label>
//                   <input
//                     type="number"
//                     value={productForm.sellingPrice}
//                     onChange={(e) => handleProductFormChange("sellingPrice", e.target.value)}
//                     style={styles.input}
//                     placeholder="0.00"
//                     min="0"
//                     step="0.01"
//                   />
//                 </div>
//               </div>
//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
//                 <div style={styles.inputGroup}>
//                   <label style={styles.label}>Purchase Tax</label>
//                   <select
//                     value={productForm.purchaseTax}
//                     onChange={(e) => handleProductFormChange("purchaseTax", e.target.value)}
//                     style={styles.select}
//                   >
//                     <option value="0">0%</option>
//                     <option value="5">5%</option>
//                     <option value="12">12%</option>
//                     <option value="18">18%</option>
//                     <option value="28">28%</option>
//                   </select>
//                 </div>
//                 <div style={styles.inputGroup}>
//                   <label style={styles.label}>Sales Tax</label>
//                   <select
//                     value={productForm.salesTax}
//                     onChange={(e) => handleProductFormChange("salesTax", e.target.value)}
//                     style={styles.select}
//                   >
//                     <option value="0">0%</option>
//                     <option value="5">5%</option>
//                     <option value="12">12%</option>
//                     <option value="18">18%</option>
//                     <option value="28">28%</option>
//                   </select>
//                 </div>
//               </div>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>Style No</label>
//                 <input
//                   type="text"
//                   value={productForm.styleNo}
//                   onChange={(e) => handleProductFormChange("styleNo", e.target.value)}
//                   style={styles.input}
//                   placeholder="Enter style number"
//                 />
//               </div>
//               <div style={styles.buttonContainer}>
//                 <button
//                   onClick={() => setShowAddProductForm(false)}
//                   style={styles.cancelButton}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={addProduct}
//                   style={styles.submitButton}
//                 >
//                   Add Product
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem', marginBottom: '2rem' }}>
//         <div style={styles.inputGroup}>
//           <label style={styles.label}>Ref No</label>
//           <input
//             type="number"
//             value={refNo}
//             readOnly
//             style={{ ...styles.input, ...styles.disabledInput }}
//           />
//         </div>
//         <div style={styles.inputGroup}>
//           <label style={styles.label}>Ref Date</label>
//           <input
//             type="date"
//             value={refDate}
//             onChange={(e) => setRefDate(e.target.value)}
//             style={styles.input}
//           />
//         </div>
//         <div style={styles.inputGroup}>
//           <label style={styles.label}>Account</label>
//           <select value={account} onChange={(e) => setAccount(e.target.value)} style={styles.select}>
//             <option value="OPENING STOCK">OPENING STOCK</option>
//             <option value="OTHER">OTHER</option>
//           </select>
//         </div>
//         <div style={styles.inputGroup}>
//           <label style={styles.label}>Branch</label>
//           <select value={branch} onChange={(e) => setBranch(e.target.value)} style={styles.select}>
//             {loading ? (
//               <option value="">Loading branches...</option>
//             ) : branches.length > 0 ? (
//               <>
//                 <option value="">Select Branch</option>
//                 {branches.map((branch) => (
//                   <option key={branch.id} value={branch.name}>
//                     {branch.name}
//                   </option>
//                 ))}
//               </>
//             ) : branchProfile ? (
//               <option value={branchProfile.branchName}>{branchProfile.branchName}</option>
//             ) : (
//               <option value="WAREHOUSE">WAREHOUSE</option>
//             )}
//             <option value="OTHER">OTHER</option>
//           </select>
//         </div>
//         <div style={styles.inputGroup}>
//           <label style={styles.label}>Location</label>
//           <select value={location} onChange={(e) => setLocation(e.target.value)} style={styles.select}>
//             <option value="WAREHOUSE">WAREHOUSE</option>
//             <option value="OTHER">OTHER</option>
//           </select>
//         </div>
//       </div>

//       {loading ? (
//         <div style={styles.loading}>⏳ Loading...</div>
//       ) : (
//         <div style={styles.tableContainer}>
//           <table style={styles.table}>
//             <thead>
//               <tr>
//                 <th style={styles.th}>S NO</th>
//                 <th style={styles.th}>ITEM DESCRIPTION</th>
//                 <th style={styles.th}>UOM</th>
//                 <th style={styles.th}>QTY (TAQ)</th>
//                 <th style={styles.th}>TAX (%)</th>
//                 <th style={styles.th}>TAX AMT</th>
//                 <th style={styles.th}>MRP</th>
//                 <th style={styles.th}>VALUE</th>
//               </tr>
//             </thead>
//             <tbody>
//               {items.map((item, index) => (
//                 <tr
//                   key={index}
//                   style={{
//                     backgroundColor: index % 2 === 0 ? '#f7fafc' : 'white',
//                     transition: 'background-color 0.2s ease',
//                   }}
//                 >
//                   <td style={{ ...styles.td, textAlign: 'center', fontWeight: '600', color: '#2563eb' }}>
//                     {index + 1}
//                   </td>
//                   <td style={styles.td}>
//                     <div style={{ position: 'relative' }}>
//                       <input
//                         type="text"
//                         value={item.itemDescription}
//                         onChange={(e) => handleItemChange(index, "itemDescription", e.target.value)}
//                         onKeyDown={(e) => handleKeyDown(e, index)}
//                         style={styles.input}
//                         placeholder="Search product..."
//                       />
//                       {focusedItemIndex === index && suggestions.length > 0 && (
//                         <div style={styles.suggestions}>
//                           <table style={styles.suggestionTable}>
//                             <thead>
//                               <tr>
//                                 <th style={styles.suggestionTh}>CODE</th>
//                                 <th style={styles.suggestionTh}>PRODUCT</th>
//                                 <th style={styles.suggestionTh}>RACK</th>
//                                 <th style={styles.suggestionTh}>BRAND</th>
//                                 <th style={styles.suggestionTh}>S.PRICE</th>
//                                 <th style={styles.suggestionTh}>QTY</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {suggestions.map((product, idx) => (
//                                 <tr
//                                   key={product.id}
//                                   ref={(el) => (suggestionRefs.current[idx] = el)}
//                                   style={{
//                                     ...styles.suggestionItem,
//                                     ...(activeSuggestionIndex === idx ? styles.suggestionActive : {}),
//                                   }}
//                                   onClick={() => handleSelect(index, product)}
//                                   onMouseEnter={() => setActiveSuggestionIndex(idx)}
//                                 >
//                                   <td style={styles.suggestionTd}>{products.findIndex(p => p.id === product.id) + 1}</td>
//                                   <td style={styles.suggestionTd}>{product.productName || 'Unknown Product'}</td>
//                                   <td style={styles.suggestionTd}>{product.rack || 'N/A'}</td>
//                                   <td style={styles.suggestionTd}>{product.brand || 'GENERAL'}</td>
//                                   <td style={styles.suggestionTd}>₹{parseFloat(product.sellingPrice || 0).toFixed(2)}</td>
//                                   <td style={styles.suggestionTd}>{product.openingStock || '0'}</td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       )}
//                     </div>
//                   </td>
//                   <td style={styles.td}>
//                     <input
//                       type="text"
//                       value={item.uom}
//                       onChange={(e) => handleItemChange(index, "uom", e.target.value)}
//                       style={{ ...styles.input, ...styles.disabledInput }}
//                       disabled
//                     />
//                   </td>
//                   <td style={styles.td}>
//                     <input
//                       type="number"
//                       value={item.qty}
//                       onChange={(e) => handleItemChange(index, "qty", e.target.value)}
//                       style={styles.input}
//                       min="0"
//                     />
//                   </td>
//                   <td style={styles.td}>
//                     <input
//                       type="number"
//                       value={item.tax}
//                       onChange={(e) => handleItemChange(index, "tax", e.target.value)}
//                       style={{ ...styles.input, ...styles.disabledInput }}
//                       disabled
//                     />
//                   </td>
//                   <td style={styles.td}>
//                     <input
//                       type="number"
//                       value={item.taxAmount}
//                       style={{ ...styles.input, ...styles.disabledInput }}
//                       disabled
//                     />
//                   </td>
//                   <td style={styles.td}>
//                     <input
//                       type="number"
//                       value={item.mrp}
//                       onChange={(e) => handleItemChange(index, "mrp", e.target.value)}
//                       style={{ ...styles.input, ...styles.disabledInput }}
//                       disabled
//                     />
//                   </td>
//                   <td style={styles.td}>
//                     <input
//                       type="number"
//                       value={item.value}
//                       style={{ ...styles.input, ...styles.disabledInput }}
//                       disabled
//                     />
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       <div style={styles.buttonContainer}>
//         <button
//           onClick={addNewLine}
//           style={styles.button}
//           disabled={loading}
//           onMouseEnter={(e) => {
//             e.target.style.transform = 'translateY(-2px)';
//             e.target.style.boxShadow = '0 6px 20px rgba(37, 99, 235, 0.4)';
//           }}
//           onMouseLeave={(e) => {
//             e.target.style.transform = 'translateY(0)';
//             e.target.style.boxShadow = '0 4px 15px rgba(37, 99, 235, 0.3)';
//           }}
//         >
//           + New Line
//         </button>
//         <button
//           onClick={saveToFirestore}
//           style={styles.submitButton}
//           disabled={loading}
//         >
//           {initialData?.id ? 'Update' : 'Save'}
//         </button>
//         <button
//           onClick={cancel}
//           style={styles.cancelButton}
//           disabled={loading}
//         >
//           Cancel
//         </button>
//       </div>

//       <style jsx>{`
//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }
//         input:focus, select:focus {
//           outline: none;
//           border-color: #2563eb;
//           box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
//         }
//         input:hover, select:hover {
//           border-color: #a1a1aa;
//         }
//         button:hover:not(:disabled) {
//           filter: brightness(90%);
//         }
//         @media (max-width: 768px) {
//           .container {
//             padding: 1rem;
//           }
//           .header {
//             flex-direction: column;
//             gap: 1rem;
//           }
//           .buttonContainer {
//             flex-direction: column;
//           }
//           .button,
//           .submitButton,
//           .cancelButton {
//             width: 100%;
//             justify-content: center;
//           }
//           .modalContent {
//             width: 90%;
//             padding: 1rem;
//           }
//           .inputGroup {
//             grid-template-columns: 1fr;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default OpeningStock;

import React, { useState, useEffect, useRef } from "react";
import { getDatabase, ref, push, set, onValue, off, update, get } from "firebase/database";
import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";

const OpeningStock = ({ onSuccess, onCancel, initialData }) => {
  const [items, setItems] = useState(
    initialData?.items || [
      { itemDescription: "", uom: "", qty: "", tax: "", taxAmount: "", mrp: "", value: "" },
    ]
  );
  const [account, setAccount] = useState(initialData?.account || "OPENING STOCK");
  const [branch, setBranch] = useState(initialData?.branch || "");
  const [location, setLocation] = useState(initialData?.location || "WAREHOUSE");
  const [refNo, setRefNo] = useState(initialData?.refNo || 1);
  const [refDate, setRefDate] = useState(
    initialData?.refDate || new Date().toISOString().split('T')[0]
  );
  const [showAddProductForm, setShowAddProductForm] = useState(false);
  const [productForm, setProductForm] = useState({
    productCode: "",
    hsnCode: "",
    productName: "",
    barcode: "",
    group: "",
    category: "",
    brand: "",
    uom: "",
    mrp: "",
    sellingPrice: "",
    purchaseTax: "0",
    salesTax: "0",
    styleNo: "",
  });
  const [currentUser, setCurrentUser] = useState(null);
  const [groups, setGroups] = useState([]);
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [units, setUnits] = useState([]);
  const [products, setProducts] = useState([]);
  const [branches, setBranches] = useState([]);
  const [branchProfile, setBranchProfile] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [suggestions, setSuggestions] = useState([]);
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(-1);
  const [focusedItemIndex, setFocusedItemIndex] = useState(null);
  const suggestionRefs = useRef([]);

  const database = getDatabase();

  const encodeEmailForPath = (email) => {
    if (!email) return "";
    return email.replace(/[.#$[\]]/g, "_");
  };

  // Fetch current user
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  // Fetch max Ref No
  useEffect(() => {
    if (!currentUser || initialData) return;

    const encodedEmail = encodeEmailForPath(currentUser.email);
    const stockRef = ref(database, `users/${encodedEmail}/openingStock`);
    get(stockRef)
      .then((snapshot) => {
        let maxRefNo = 0;
        if (snapshot.exists()) {
          const stockEntries = snapshot.val();
          const refNos = Object.values(stockEntries)
            .map((entry) => parseInt(entry.refNo, 10))
            .filter((num) => !isNaN(num));
          maxRefNo = refNos.length > 0 ? Math.max(...refNos) : 0;
        }
        setRefNo(maxRefNo + 1 || 1);
      })
      .catch((error) => {
        console.error('Error fetching Ref No:', error);
        setErrorMessage('Failed to fetch Ref No.');
      });
  }, [currentUser, initialData]);

  // Fetch groups, categories, brands, units, products, branches, and branch profile
  useEffect(() => {
    if (!currentUser || !currentUser.email) return;

    setLoading(true);
    const encodedEmail = encodeEmailForPath(currentUser.email);
    if (!encodedEmail) {
      setErrorMessage("Invalid user email. Cannot fetch data.");
      setLoading(false);
      return;
    }

    const groupsRef = ref(database, `users/${encodedEmail}/productGroups`);
    const categoriesRef = ref(database, `users/${encodedEmail}/categories`);
    const brandsRef = ref(database, `users/${encodedEmail}/brands`);
    const unitsRef = ref(database, `users/${encodedEmail}/units`);
    const productsRef = ref(database, `users/${encodedEmail}/products`);
    const branchesRef = ref(database, `users/${encodedEmail}/branches`);
    const branchProfileRef = ref(database, `users/${encodedEmail}/branchProfiles`);

    const listeners = [
      { ref: groupsRef, setData: setGroups },
      { ref: categoriesRef, setData: setCategories },
      { ref: brandsRef, setData: setBrands },
      { ref: unitsRef, setData: setUnits },
      { ref: productsRef, setData: setProducts },
      { ref: branchesRef, setData: setBranches },
    ];

    listeners.forEach(({ ref, setData }) => {
      onValue(
        ref,
        (snapshot) => {
          const data = [];
          snapshot.forEach((childSnapshot) => {
            data.push({ id: childSnapshot.key, ...childSnapshot.val() });
          });
          setData(data);
        },
        (error) => {
          console.error(`Error fetching data:`, error);
          setErrorMessage(`Failed to load data: ${error.message}`);
        }
      );
    });

    // Fetch branch profile
    onValue(
      branchProfileRef,
      (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const profiles = Object.values(data);
          if (profiles.length > 0) {
            const latestProfile = profiles[profiles.length - 1];
            setBranchProfile(latestProfile);
            if (!initialData) {
              setBranch(latestProfile.branchName || "WAREHOUSE");
            }
          }
        }
        setLoading(false);
      },
      (error) => {
        console.error("Error fetching branch profile:", error);
        setErrorMessage(`Failed to load branch profile: ${error.message}`);
        setLoading(false);
      }
    );

    return () => {
      listeners.forEach(({ ref }) => off(ref));
      off(branchProfileRef);
    };
  }, [currentUser, initialData]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        suggestionRefs.current.every((ref) => ref && !ref.contains(e.target)) &&
        !e.target.closest('input')
      ) {
        setSuggestions([]);
        setFocusedItemIndex(null);
        setActiveSuggestionIndex(-1);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  // Handle item changes
  const handleItemChange = (index, field, value) => {
    const updatedItems = [...items];
    if (field === "itemDescription") {
      updatedItems[index][field] = value;
      if (value.trim()) {
        const filtered = products.filter((p) =>
          p.productName && p.productName.toLowerCase().includes(value.toLowerCase())
        );
        setSuggestions(filtered.slice(0, 5));
        setFocusedItemIndex(index);
        setActiveSuggestionIndex(-1);
      } else {
        setSuggestions([]);
        setFocusedItemIndex(null);
      }
    } else {
      updatedItems[index][field] = value;
    }

    if (field === "qty" || field === "tax" || field === "mrp") {
      const qty = parseFloat(updatedItems[index].qty) || 0;
      const tax = parseFloat(updatedItems[index].tax) || 0;
      const mrp = parseFloat(updatedItems[index].mrp) || 0;

      const taxAmount = (mrp * qty * tax) / 100;
      const value = mrp * qty + taxAmount;

      updatedItems[index].taxAmount = taxAmount.toFixed(2);
      updatedItems[index].value = value.toFixed(2);
    }

    setItems(updatedItems);
  };

  const handleSelect = (index, product) => {
    const updatedItems = [...items];
    updatedItems[index] = {
      itemDescription: product.productName || "",
      uom: product.uom || product.unit || "",
      qty: updatedItems[index].qty || "",
      tax: product.salesTax || "0",
      taxAmount: "",
      mrp: product.mrp || "0",
      value: "",
    };
    const qty = parseFloat(updatedItems[index].qty) || 0;
    const tax = parseFloat(updatedItems[index].tax) || 0;
    const mrp = parseFloat(updatedItems[index].mrp) || 0;
    const taxAmount = (mrp * qty * tax) / 100;
    const value = mrp * qty + taxAmount;
    updatedItems[index].taxAmount = taxAmount.toFixed(2);
    updatedItems[index].value = value.toFixed(2);
    setItems(updatedItems);
    setSuggestions([]);
    setFocusedItemIndex(null);
    setActiveSuggestionIndex(-1);
  };

  const handleKeyDown = (e, index) => {
    if (focusedItemIndex !== index || suggestions.length === 0) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActiveSuggestionIndex((prev) =>
        prev < suggestions.length - 1 ? prev + 1 : prev
      );
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActiveSuggestionIndex((prev) => (prev > 0 ? prev - 1 : prev));
    } else if (e.key === 'Enter' && activeSuggestionIndex >= 0) {
      e.preventDefault();
      handleSelect(index, suggestions[activeSuggestionIndex]);
    } else if (e.key === 'Escape') {
      setSuggestions([]);
      setFocusedItemIndex(null);
      setActiveSuggestionIndex(-1);
    }
  };

  const addNewLine = () => {
    setItems([
      ...items,
      { itemDescription: "", uom: "", qty: "", tax: "", taxAmount: "", mrp: "", value: "" },
    ]);
  };

const saveToFirestore = async () => {
  setErrorMessage("");
  setSuccessMessage("");
  if (!currentUser || !currentUser.email) {
    alert("You must be logged in with a valid email to save data!");
    return;
  }

  const encodedEmail = encodeEmailForPath(currentUser.email);
  try {
    const nonEmptyItems = items.filter(
      (item) =>
        item.itemDescription.trim() !== "" &&
        item.qty !== "" &&
        item.mrp !== "" &&
        !isNaN(parseFloat(item.qty)) &&
        !isNaN(parseFloat(item.mrp))
    );

    if (nonEmptyItems.length === 0) {
      alert("Please add at least one valid item with product, quantity, and MRP!");
      return;
    }

    const stockData = {
      refNo,
      refDate,
      account,
      branch,
      location,
      items: nonEmptyItems,
      createdAt: new Date().toISOString(),
    };

    if (initialData?.id) {
      // Update existing stock entry
      const stockRef = ref(database, `users/${encodedEmail}/openingStock/${initialData.id}`);
      await update(stockRef, stockData);
      alert("Stock updated successfully!");
    } else {
      // Create new stock entry
      const newStockRef = push(ref(database, `users/${encodedEmail}/openingStock`));
      await set(newStockRef, stockData);
      alert("Stock saved successfully!");
    }

    onSuccess();
  } catch (error) {
    console.error("Error saving data:", error);
    alert(`Failed to save data: ${error.message}`);
  }
};
  const handleProductFormChange = (field, value) => {
    setProductForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const addProduct = async () => {
    setErrorMessage("");
    setSuccessMessage("");
    if (!currentUser || !currentUser.email) {
      setErrorMessage("You must be logged in with a valid email to add a product!");
      return;
    }

    const encodedEmail = encodeEmailForPath(currentUser.email);
    try {
      if (!productForm.productName || !productForm.uom) {
        setErrorMessage("Please fill all required fields (Product Name, UOM)!");
        return;
      }

      const productData = {
        ...productForm,
        createdAt: new Date().toISOString(),
        createdBy: currentUser.email,
        mrp: parseFloat(productForm.mrp) || 0,
        sellingPrice: parseFloat(productForm.sellingPrice) || 0,
        purchaseTax: parseFloat(productForm.purchaseTax) || 0,
        salesTax: parseFloat(productForm.salesTax) || 0,
        openingStock: "0",
      };

      const newProductRef = push(ref(database, `users/${encodedEmail}/products`));
      await set(newProductRef, productData);

      setSuccessMessage("Product added successfully!");
      setShowAddProductForm(false);
      setProductForm({
        productCode: "",
        hsnCode: "",
        productName: "",
        barcode: "",
        group: "",
        category: "",
        brand: "",
        uom: "",
        mrp: "",
        sellingPrice: "",
        purchaseTax: "0",
        salesTax: "0",
        styleNo: "",
      });
    } catch (error) {
      console.error("Error adding product:", error);
      setErrorMessage(`Failed to add product: ${error.message}`);
    }
  };

  const cancel = () => {
    setItems([{ itemDescription: "", uom: "", qty: "", tax: "", taxAmount: "", mrp: "", value: "" }]);
    setAccount("OPENING STOCK");
    setBranch(branchProfile?.branchName || "WAREHOUSE");
    setLocation("WAREHOUSE");
    setRefDate(new Date().toISOString().split('T')[0]);
    setErrorMessage("");
    setSuccessMessage("");
    setShowAddProductForm(false);
    onCancel();
  };

  // Styles
  const styles = {
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '2rem',
      backgroundColor: 'white',
      minHeight: '100vh',
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '2rem',
      padding: '1.5rem',
    },
    heading: {
      fontSize: '2rem',
      fontWeight: '700',
      color: '#2563eb',
      margin: '0',
      
    },
    button: {
      padding: '0.875rem 2rem',
      borderRadius: '8px',
      backgroundColor: '#2563eb',
      color: 'white',
      fontWeight: '600',
      cursor: 'pointer',
      border: 'none',
      fontSize: '0.95rem',
      transition: 'all 0.3s ease',
      boxShadow: '0 4px 15px rgba(37, 99, 235, 0.3)',
      transform: 'translateY(0)',
    },
    button1: {
      padding: '0.875rem 2rem',
      borderRadius: '8px',
      backgroundColor: '#2563eb',
      color: 'white',
      fontWeight: '600',
      cursor: 'pointer',
      border: 'none',
      fontSize: '0.95rem',
      transition: 'all 0.3s ease',
      boxShadow: '0 4px 15px rgba(37, 99, 235, 0.3)',
      transform: 'translateY(0)',
      marginLeft: '900px',
    },
    tableContainer: {
      backgroundColor: 'white',
      borderRadius: '16px',
      boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e2e8f0',
      marginBottom: '2rem',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '0.9rem',
      border: '1px solid #d1d5db',
    },
    th: {
      padding: '1rem 0.75rem',
      textAlign: 'left',
      backgroundColor: '#2563eb',
      color: 'white',
      fontWeight: '600',
      fontSize: '0.85rem',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      border: '1px solid #1e40af',
    },
    td: {
      padding: '1rem 0.75rem',
      border: '1px solid #d1d5db',
      color: '#374151',
      verticalAlign: 'middle',
    },
    input: {
      display: 'block',
      width: '80%',
      padding: '0.5rem 0.75rem',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontSize: '0.875rem',
      backgroundColor: '#fff',
      transition: 'border-color 0.2s ease',
    },
    select: {
      display: 'block',
      width: '100%',
      padding: '0.5rem 0.75rem',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontSize: '0.875rem',
      backgroundColor: '#fff',
      cursor: 'pointer',
      appearance: 'none',
      backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e")`,
      backgroundPosition: 'right 0.5rem center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '1em 1em',
      paddingRight: '2rem',
    },
    disabledInput: {
      backgroundColor: '#f3f4f6',
      cursor: 'not-allowed',
    },
    suggestions: {
      position: 'absolute',
      top: '100%',
      left: '0',
      width: '100%',
      backgroundColor: '#ffffff',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      zIndex: 1000,
      maxHeight: '300px',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    },
    suggestionTable: {
      width: '100%',
      borderCollapse: 'collapse',
    },
    suggestionTh: {
      padding: '0.5rem',
      backgroundColor: '#2563eb',
      color: 'white',
      fontWeight: '600',
      fontSize: '0.7rem',
      textAlign: 'center',
      border: '1px solid #1e40af',
    },
    suggestionTd: {
      padding: '0.5rem',
      border: '1px solid #e2e8f0',
      fontSize: '0.75rem',
      textAlign: 'center',
    },
    suggestionItem: {
      cursor: 'pointer',
      transition: 'background-color 0.2s ease',
    },
    suggestionActive: {
      backgroundColor: '#e0f2fe',
    },
    messageSuccess: {
      padding: '1rem 1.5rem',
      marginBottom: '1.5rem',
      borderRadius: '12px',
      backgroundColor: '#d1fae5',
      color: '#065f46',
      border: '1px solid #a7f3d0',
      fontSize: '0.9rem',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
    messageError: {
      padding: '1rem 1.5rem',
      marginBottom: '1.5rem',
      borderRadius: '12px',
      backgroundColor: '#fee2e2',
      color: '#b91c1c',
      border: '1px solid #fecaca',
      fontSize: '0.9rem',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
    modal: {
      position: 'fixed',
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    },
    modalContent: {
      backgroundColor: 'white',
      borderRadius: '16px',
      width: '600px',
      maxHeight: '90vh',
      overflow: 'auto',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      padding: '2rem',
    },
    modalHeader: {
      backgroundColor: '#2563eb',
      color: 'white',
      padding: '1rem 1.5rem',
      borderRadius: '12px 12px 0 0',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    modalCloseButton: {
      background: 'none',
      border: 'none',
      color: 'white',
      fontSize: '1.25rem',
      cursor: 'pointer',
      padding: '0.25rem',
    },
    formSection: {
      padding: '1.5rem',
      border: '1px solid #e2e8f0',
      borderRadius: '8px',
      marginBottom: '1.5rem',
      backgroundColor: '#fff',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
    },
    sectionHeading: {
      fontSize: '1.25rem',
      fontWeight: '600',
      marginBottom: '1rem',
      color: '#1f2937',
    },
    inputGroup: {
      marginBottom: '1rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
    },
    label: {
      display: 'block',
      fontSize: '0.875rem',
      fontWeight: '500',
      color: '#374151',
      marginBottom: '0.25rem',
    },
    requiredAsterisk: {
      color: '#ef4444',
      marginLeft: '0.25rem',
    },
    buttonContainer: {
      marginTop: '2rem',
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '1rem',
      paddingTop: '1rem',
      borderTop: '1px solid #e2e8f0',
    },
    submitButton: {
      padding: '0.5rem 1.5rem',
      borderRadius: '6px',
      fontWeight: '500',
      fontSize: '0.875rem',
      cursor: 'pointer',
      border: 'none',
      backgroundColor: '#10b981',
      color: 'white',
      transition: 'all 0.2s ease',
    },
    cancelButton: {
      padding: '0.5rem 1.5rem',
      borderRadius: '6px',
      fontWeight: '500',
      fontSize: '0.875rem',
      cursor: 'pointer',
      border: 'none',
      backgroundColor: '#ef4444',
      color: 'white',
      transition: 'all 0.2s ease',
    },
    editButton: {
      padding: '0.5rem 1rem',
      borderRadius: '6px',
      fontWeight: '500',
      fontSize: '0.875rem',
      cursor: 'pointer',
      border: 'none',
      backgroundColor: '#f59e0b',
      color: 'white',
      transition: 'all 0.2s ease',
      marginRight: '0.5rem',
    },
    deleteButton: {
      padding: '0.5rem 1rem',
      borderRadius: '6px',
      fontWeight: '500',
      fontSize: '0.875rem',
      cursor: 'pointer',
      border: 'none',
      backgroundColor: '#dc2626',
      color: 'white',
      transition: 'all 0.2s ease',
    },
    loading: {
      textAlign: 'center',
      padding: '4rem',
      color: '#718096',
      fontSize: '1.1rem',
    },
  };

  return (
    <div style={styles.container}>
      {successMessage && (
        <div style={styles.messageSuccess}>
          <span>✅</span>
          {successMessage}
        </div>
      )}
      {errorMessage && (
        <div style={styles.messageError}>
          <span>❌</span>
          {errorMessage}
        </div>
      )}

      <div style={styles.header}>
        <h2 style={styles.heading}>Opening Stock</h2>
        <button
          onClick={() => setShowAddProductForm(true)}
          style={styles.button1}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 20px rgba(37, 99, 235, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 15px rgba(37, 99, 235, 0.3)';
          }}
          disabled={loading}
        >
          + New Product
        </button>
      </div>

      {showAddProductForm && (
        <div style={styles.modal}>
          <div style={styles.modalContent}>
            <div style={styles.modalHeader}>
              <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: '600' }}>Add Product</h3>
              <button
                onClick={() => setShowAddProductForm(false)}
                style={styles.modalCloseButton}
              >
                ✕
              </button>
            </div>
            <div style={styles.formSection}>
              {successMessage && (
                <div style={styles.messageSuccess}>
                  <span>✅</span>
                  {successMessage}
                </div>
              )}
              {errorMessage && (
                <div style={styles.messageError}>
                  <span>❌</span>
                  {errorMessage}
                </div>
              )}
              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  Product Code<span style={styles.requiredAsterisk}>*</span>
                </label>
                <input
                  type="text"
                  value={productForm.productCode}
                  onChange={(e) => handleProductFormChange("productCode", e.target.value)}
                  style={styles.input}
                  placeholder="Enter product code"
                  required
                />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>HSN Code</label>
                <input
                  type="text"
                  value={productForm.hsnCode}
                  onChange={(e) => handleProductFormChange("hsnCode", e.target.value)}
                  style={styles.input}
                  placeholder="Enter HSN code"
                />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  Product Name<span style={styles.requiredAsterisk}>*</span>
                </label>
                <input
                  type="text"
                  value={productForm.productName}
                  onChange={(e) => handleProductFormChange("productName", e.target.value)}
                  style={styles.input}
                  placeholder="Enter product name"
                  required
                />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Barcode</label>
                <input
                  type="text"
                  value={productForm.barcode}
                  onChange={(e) => handleProductFormChange("barcode", e.target.value)}
                  style={styles.input}
                  placeholder="Enter barcode"
                />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Group</label>
                  <select
                    value={productForm.group}
                    onChange={(e) => handleProductFormChange("group", e.target.value)}
                    style={styles.select}
                  >
                    <option value="">SELECT GROUP</option>
                    {groups.map((group) => (
                      <option key={group.id} value={group.name}>
                        {group.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Category</label>
                  <select
                    value={productForm.category}
                    onChange={(e) => handleProductFormChange("category", e.target.value)}
                    style={styles.select}
                  >
                    <option value="">SELECT CATEGORY</option>
                    {categories.map((category) => (
                      <option key={category.id} value={category.name}>
                        {category.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Brand</label>
                  <select
                    value={productForm.brand}
                    onChange={(e) => handleProductFormChange("brand", e.target.value)}
                    style={styles.select}
                  >
                    <option value="">SELECT BRAND</option>
                    {brands.map((brand) => (
                      <option key={brand.id} value={brand.name}>
                        {brand.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>
                    UOM<span style={styles.requiredAsterisk}>*</span>
                  </label>
                  <select
                    value={productForm.uom}
                    onChange={(e) => handleProductFormChange("uom", e.target.value)}
                    style={styles.select}
                    required
                  >
                    <option value="">SELECT UOM</option>
                    {units.map((unit) => (
                      <option key={unit.id} value={unit.name}>
                        {unit.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>MRP</label>
                  <input
                    type="number"
                    value={productForm.mrp}
                    onChange={(e) => handleProductFormChange("mrp", e.target.value)}
                    style={styles.input}
                    placeholder="0.00"
                    min="0"
                    step="0.01"
                  />
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Selling Price</label>
                  <input
                    type="number"
                    value={productForm.sellingPrice}
                    onChange={(e) => handleProductFormChange("sellingPrice", e.target.value)}
                    style={styles.input}
                    placeholder="0.00"
                    min="0"
                    step="0.01"
                  />
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Purchase Tax</label>
                  <select
                    value={productForm.purchaseTax}
                    onChange={(e) => handleProductFormChange("purchaseTax", e.target.value)}
                    style={styles.select}
                  >
                    <option value="0">0%</option>
                    <option value="5">5%</option>
                    <option value="12">12%</option>
                    <option value="18">18%</option>
                    <option value="28">28%</option>
                  </select>
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Sales Tax</label>
                  <select
                    value={productForm.salesTax}
                    onChange={(e) => handleProductFormChange("salesTax", e.target.value)}
                    style={styles.select}
                  >
                    <option value="0">0%</option>
                    <option value="5">5%</option>
                    <option value="12">12%</option>
                    <option value="18">18%</option>
                    <option value="28">28%</option>
                  </select>
                </div>
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Style No</label>
                <input
                  type="text"
                  value={productForm.styleNo}
                  onChange={(e) => handleProductFormChange("styleNo", e.target.value)}
                  style={styles.input}
                  placeholder="Enter style number"
                />
              </div>
              <div style={styles.buttonContainer}>
                <button
                  onClick={() => setShowAddProductForm(false)}
                  style={styles.cancelButton}
                >
                  Cancel
                </button>
                <button
                  onClick={addProduct}
                  style={styles.submitButton}
                >
                  Add Product
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem', marginBottom: '2rem' }}>
        <div style={styles.inputGroup}>
          <label style={styles.label}>Ref No</label>
          <input
            type="number"
            value={refNo}
            readOnly
            style={{ ...styles.input, ...styles.disabledInput }}
          />
        </div>
        <div style={styles.inputGroup}>
          <label style={styles.label}>Ref Date</label>
          <input
            type="date"
            value={refDate}
            onChange={(e) => setRefDate(e.target.value)}
            style={styles.input}
          />
        </div>
        <div style={styles.inputGroup}>
          <label style={styles.label}>Account</label>
          <select value={account} onChange={(e) => setAccount(e.target.value)} style={styles.select}>
            <option value="OPENING STOCK">OPENING STOCK</option>
            <option value="OTHER">OTHER</option>
          </select>
        </div>
        <div style={styles.inputGroup}>
          <label style={styles.label}>Branch</label>
          <select value={branch} onChange={(e) => setBranch(e.target.value)} style={styles.select}>
            {loading ? (
              <option value="">Loading branches...</option>
            ) : branches.length > 0 ? (
              <>
                <option value="">Select Branch</option>
                {branches.map((branch) => (
                  <option key={branch.id} value={branch.name}>
                    {branch.name}
                  </option>
                ))}
              </>
            ) : branchProfile ? (
              <option value={branchProfile.branchName}>{branchProfile.branchName}</option>
            ) : (
              <option value="WAREHOUSE">WAREHOUSE</option>
            )}
            <option value="OTHER">OTHER</option>
          </select>
        </div>
        <div style={styles.inputGroup}>
          <label style={styles.label}>Location</label>
          <select value={location} onChange={(e) => setLocation(e.target.value)} style={styles.select}>
            <option value="WAREHOUSE">WAREHOUSE</option>
            <option value="OTHER">OTHER</option>
          </select>
        </div>
      </div>

      {loading ? (
        <div style={styles.loading}>⏳ Loading...</div>
      ) : (
        <div style={styles.tableContainer}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Sr NO</th>
                <th style={styles.th}>ITEM DESCRIPTION</th>
                <th style={styles.th}>UOM</th>
                <th style={styles.th}>QTY (TAQ)</th>
                <th style={styles.th}>TAX (%)</th>
                <th style={styles.th}>TAX AMT</th>
                <th style={styles.th}>MRP</th>
                <th style={styles.th}>VALUE</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? '#f7fafc' : 'white',
                    transition: 'background-color 0.2s ease',
                  }}
                >
                  <td style={{ ...styles.td, textAlign: 'center', fontWeight: '600', color: '#2563eb' }}>
                    {index + 1}
                  </td>
                  <td style={styles.td}>
                    <div style={{ position: 'relative' }}>
                      <input
                        type="text"
                        value={item.itemDescription}
                        onChange={(e) => handleItemChange(index, "itemDescription", e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        style={styles.input}
                        placeholder="Search product..."
                      />
                      {focusedItemIndex === index && suggestions.length > 0 && (
                        <div style={styles.suggestions}>
                          <table style={styles.suggestionTable}>
                            <thead>
                              <tr>
                                <th style={styles.suggestionTh}>CODE</th>
                                <th style={styles.suggestionTh}>PRODUCT</th>
                                <th style={styles.suggestionTh}>RACK</th>
                                <th style={styles.suggestionTh}>BRAND</th>
                                <th style={styles.suggestionTh}>S.PRICE</th>
                                <th style={styles.suggestionTh}>QTY</th>
                              </tr>
                            </thead>
                            <tbody>
                              {suggestions.map((product, idx) => (
                                <tr
                                  key={product.id}
                                  ref={(el) => (suggestionRefs.current[idx] = el)}
                                  style={{
                                    ...styles.suggestionItem,
                                    ...(activeSuggestionIndex === idx ? styles.suggestionActive : {}),
                                  }}
                                  onClick={() => handleSelect(index, product)}
                                  onMouseEnter={() => setActiveSuggestionIndex(idx)}
                                >
                                  <td style={styles.suggestionTd}>{products.findIndex(p => p.id === product.id) + 1}</td>
                                  <td style={styles.suggestionTd}>{product.productName || 'Unknown Product'}</td>
                                  <td style={styles.suggestionTd}>{product.rack || 'N/A'}</td>
                                  <td style={styles.suggestionTd}>{product.brand || 'GENERAL'}</td>
                                  <td style={styles.suggestionTd}>₹{parseFloat(product.sellingPrice || 0).toFixed(2)}</td>
                                  <td style={styles.suggestionTd}>{product.openingStock || '0'}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </td>
                  <td style={styles.td}>
                    <input
                      type="text"
                      value={item.uom}
                      onChange={(e) => handleItemChange(index, "uom", e.target.value)}
                      style={{ ...styles.input, ...styles.disabledInput }}
                      disabled
                    />
                  </td>
                  <td style={styles.td}>
                    <input
                      type="number"
                      value={item.qty}
                      onChange={(e) => handleItemChange(index, "qty", e.target.value)}
                      style={styles.input}
                      min="0"
                    />
                  </td>
                  <td style={styles.td}>
                    <input
                      type="number"
                      value={item.tax}
                      onChange={(e) => handleItemChange(index, "tax", e.target.value)}
                      style={{ ...styles.input, ...styles.disabledInput }}
                      disabled
                    />
                  </td>
                  <td style={styles.td}>
                    <input
                      type="number"
                      value={item.taxAmount}
                      style={{ ...styles.input, ...styles.disabledInput }}
                      disabled
                    />
                  </td>
                  <td style={styles.td}>
                    <input
                      type="number"
                      value={item.mrp}
                      onChange={(e) => handleItemChange(index, "mrp", e.target.value)}
                      style={{ ...styles.input, ...styles.disabledInput }}
                      disabled
                    />
                  </td>
                  <td style={styles.td}>
                    <input
                      type="number"
                      value={item.value}
                      style={{ ...styles.input, ...styles.disabledInput }}
                      disabled
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div style={styles.buttonContainer}>
        <button
          onClick={addNewLine}
          style={styles.button}
          disabled={loading}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 20px rgba(37, 99, 235, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 15px rgba(37, 99, 235, 0.3)';
          }}
        >
          + New Line
        </button>
        <button
          onClick={saveToFirestore}
          style={styles.submitButton}
          disabled={loading}
        >
          {initialData?.id ? 'Update' : 'Save'}
        </button>
        <button
          onClick={cancel}
          style={styles.cancelButton}
          disabled={loading}
        >
          Cancel
        </button>
      </div>

      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        input:focus, select:focus {
          outline: none;
          border-color: #2563eb;
          box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
        }
        input:hover, select:hover {
          border-color: #a1a1aa;
        }
        button:hover:not(:disabled) {
          filter: brightness(90%);
        }
        @media (max-width: 768px) {
          .container {
            padding: 1rem;
          }
          .header {
            flex-direction: column;
            gap: 1rem;
          }
          .buttonContainer {
            flex-direction: column;
          }
          .button,
          .submitButton,
          .cancelButton {
            width: 100%;
            justify-content: center;
          }
          .modalContent {
            width: 90%;
            padding: 1rem;
          }
          .inputGroup {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
};

export default OpeningStock;